{
  "items": [
    {
      "id": 131372485,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-10-07T09:46:11.023340",
      "modifiedAt": "2026-10-07T09:46:11.023340",
      "name": "261001 Dala Schlucht",
      "type": "normal",
      "public": true,
      "userdate": "2026-10-01",
      "meta": {
        "length": 987.6502004861832,
        "totalup": 88.2161865234375,
        "totaldown": 88.1488037109375,
        "elemin": 1467.8,
        "elemax": 1555.6,
        "walking": 25.412668490506242,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1889268631,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-10-03T19:07:13.245169",
      "modifiedAt": "2026-10-07T09:45:00.468930",
      "name": "261001 Beizu Tour",
      "type": "normal",
      "public": false,
      "userdate": "2026-10-01",
      "meta": {
        "length": 9890.14962618053,
        "totalup": 425.7100830078125,
        "totaldown": 424.3101806640625,
        "elemin": 1382.1,
        "elemax": 1668.1,
        "walking": 0.0,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 82.98471715502176,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1379326128,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-10-04T18:18:22.186725",
      "modifiedAt": "2026-10-04T18:18:58.123981",
      "name": "261004 Lätte Nebikon",
      "type": "normal",
      "public": true,
      "userdate": "2026-10-04",
      "meta": {
        "length": 40169.73839378357,
        "totalup": 534.1001892089844,
        "totaldown": 531.4001770019531,
        "elemin": 457.0,
        "elemax": 752.3,
        "walking": 601.8277975432233,
        "biking": 213.74355515474195,
        "eBiking": 203.67839994482003,
        "winterHiking": 752.3,
        "snowshoeTrekking": 902.7,
        "mountainBiking": 199.44980384424446,
        "eMountainBiking": 127.07757609771096
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 842086039,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-10-04T18:21:26.870188",
      "modifiedAt": "2026-10-04T18:21:26.870188",
      "name": "260913 Fräkmünt Pilatus",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-13",
      "meta": {
        "length": 4330.531210660934,
        "totalup": 789.103759765625,
        "totaldown": 131.20947265625,
        "elemin": 1332.5,
        "elemax": 2074.4,
        "walking": 152.4457040488289,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 860179730,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-08-16T17:58:49.048560",
      "modifiedAt": "2026-10-03T21:54:59.766389",
      "name": "260816 Willisau Emmenbrücke",
      "type": "normal",
      "public": true,
      "userdate": "2026-08-16",
      "meta": {
        "length": 74029.49060594384,
        "totalup": 957.9000244140625,
        "totaldown": 968.0000305175781,
        "elemin": 426.29998779296875,
        "elemax": 734.8999938964844,
        "walking": 1090.2542481046369,
        "biking": 355.814637882938,
        "eBiking": 339.1951720332134,
        "winterHiking": 1362.8,
        "snowshoeTrekking": 1635.4,
        "mountainBiking": 356.13744958556975,
        "eMountainBiking": 221.73155345056088
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 411927556,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-10-03T18:52:51.654703",
      "modifiedAt": "2026-10-03T21:53:31.372109",
      "name": "260929 Häxutrail Belalp",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-29",
      "meta": {
        "length": 6342.492077066406,
        "totalup": 44.99993896484375,
        "totaldown": 809.699951171875,
        "elemin": 1330.0999755859375,
        "elemax": 2094.7999877929688,
        "walking": 111.86612489845152,
        "biking": 14.809589816802582,
        "eBiking": 11.896319879986635,
        "winterHiking": 139.79999999999998,
        "snowshoeTrekking": 167.89999999999998,
        "mountainBiking": 16.262612866751613,
        "eMountainBiking": 12.150494782250693
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1897374413,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2025-10-10T10:41:28.467716",
      "modifiedAt": "2026-10-03T21:49:41.413917",
      "name": "251010 E-Bike Foodtrail Emmental",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-10",
      "meta": {
        "length": 36066.64439369618,
        "totalup": 719.0999450683594,
        "totaldown": 719.0999450683594,
        "elemin": 580.0,
        "elemax": 839.3999938964844,
        "walking": 540.3849355627395,
        "biking": 215.67477359917243,
        "eBiking": 138.10184728801235,
        "winterHiking": 675.6999999999999,
        "snowshoeTrekking": 810.6,
        "mountainBiking": 204.9622766259468,
        "eMountainBiking": 122.55301413299021
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "e_velo"
      }
    },
    {
      "id": 227997784,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2026-09-24T18:56:52.823547",
      "modifiedAt": "2026-10-03T21:49:27.581789",
      "name": "260924 Foodtrail Thurgau",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-24",
      "meta": {
        "length": 39815.29847176138,
        "totalup": 444.49993896484375,
        "totaldown": 444.49993896484375,
        "elemin": 393.29998779296875,
        "elemax": 594.0,
        "walking": 579.4963649901948,
        "biking": 148.75518709538142,
        "eBiking": 110.42679358931112,
        "winterHiking": 724.1000000000001,
        "snowshoeTrekking": 869.4000000000001,
        "mountainBiking": 182.08433351193077,
        "eMountainBiking": 115.20780103895946
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "e_velo"
      }
    },
    {
      "id": 1838746820,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-09-03T20:54:08.750843",
      "modifiedAt": "2026-10-03T21:46:37.597581",
      "name": "260904 Maighels",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-04",
      "meta": {
        "length": 34950.18207514107,
        "totalup": 1383.1722412109375,
        "totaldown": 1383.2879638671875,
        "elemin": 1435.5,
        "elemax": 2421.5,
        "walking": 459.7414774830109,
        "biking": 233.0267930245896,
        "eBiking": 127.07857682438485,
        "winterHiking": 574.7,
        "snowshoeTrekking": 689.6,
        "mountainBiking": 281.9554662565327,
        "eMountainBiking": 132.71942066119226
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 22689231,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-10-03T18:59:27.124484",
      "modifiedAt": "2026-10-03T21:44:55.220484",
      "name": "260930 Torrenttrail",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-30",
      "meta": {
        "length": 11273.815057187521,
        "totalup": 153.29974365234375,
        "totaldown": 1076.2997436523438,
        "elemin": 1298.2999877929688,
        "elemax": 2306.5,
        "walking": 188.54028303429857,
        "biking": 37.65797494139394,
        "eBiking": 26.106289787983094,
        "winterHiking": 235.79999999999998,
        "snowshoeTrekking": 282.7,
        "mountainBiking": 42.46266719076872,
        "eMountainBiking": 27.330958569593413
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 827004510,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-10-03T18:54:54.607702",
      "modifiedAt": "2026-10-03T18:55:12.358619",
      "name": "260930 Torrent Wysse See",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-30",
      "meta": {
        "length": 14945.205664634705,
        "totalup": 451.4014892578125,
        "totaldown": 825.9080810546875,
        "elemin": 1925.6,
        "elemax": 2458.4,
        "walking": 252.3147704451763,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 44877528,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-10-03T19:08:49.538804",
      "modifiedAt": "2026-10-03T19:08:56.007296",
      "name": "261002 Gemmiweg",
      "type": "normal",
      "public": true,
      "userdate": "2026-10-03",
      "meta": {
        "length": 7221.773081168532,
        "totalup": 1043.545166015625,
        "totaldown": 83.682861328125,
        "elemin": 1378.7,
        "elemax": 2340.7,
        "walking": 204.81560080422702,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 588322377,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-10-03T18:51:01.055546",
      "modifiedAt": "2026-10-03T18:51:01.055546",
      "name": "260928 Belalp Riederfurka",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-28",
      "meta": {
        "length": 12635.495872870088,
        "totalup": 1523.43115234375,
        "totaldown": 723.1943359375,
        "elemin": 1330.6,
        "elemax": 2132.6,
        "walking": 356.5229138970135,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 197519993,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-10-03T18:47:48.527909",
      "modifiedAt": "2026-10-03T18:48:03.133914",
      "name": "260927 Sparrhorn",
      "type": "normal",
      "public": true,
      "userdate": "2026-09-27",
      "meta": {
        "length": 8630.129429519176,
        "totalup": 889.305908203125,
        "totaldown": 889.17431640625,
        "elemin": 2130.9,
        "elemax": 3019.4,
        "walking": 239.94657687348857,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 160761985,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-08-03T18:25:13.309724",
      "modifiedAt": "2026-08-03T18:26:53.712411",
      "name": "260621 Axalp Tschingel",
      "type": "normal",
      "public": true,
      "userdate": "2026-06-21",
      "meta": {
        "length": 12494.100681414502,
        "totalup": 1189.4999633789062,
        "totaldown": 800.7999694824218,
        "elemin": 1516.0999755859375,
        "elemax": 2246.0,
        "walking": 325.4712807008709,
        "biking": 117.45117191680163,
        "eBiking": 0.0,
        "winterHiking": 406.9000000000001,
        "snowshoeTrekking": 488.2,
        "mountainBiking": 124.21054201399555,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 587241558,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-06-05T17:54:00.942924",
      "modifiedAt": "2026-08-08T17:03:55.644050",
      "name": "260605 Sursee-Napf",
      "type": "normal",
      "public": true,
      "userdate": "2026-06-05",
      "meta": {
        "length": 90893.15580451488,
        "totalup": 1647.7996215820312,
        "totaldown": 1658.4996032714844,
        "elemin": 486.4,
        "elemax": 1405.2,
        "walking": 1399.6385327905443,
        "biking": 439.43625897004,
        "eBiking": 0.0,
        "winterHiking": 1749.5,
        "snowshoeTrekking": 2099.5,
        "mountainBiking": 522.012247790371,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1557154216,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-08-03T18:27:04.874142",
      "modifiedAt": "2026-08-03T18:27:35.303856",
      "name": "260802 Silberenseeli",
      "type": "normal",
      "public": true,
      "userdate": "2026-08-02",
      "meta": {
        "length": 14119.464964391747,
        "totalup": 955.1999206542969,
        "totaldown": 955.8999328613281,
        "elemin": 1525.5,
        "elemax": 2144.0999755859375,
        "walking": 313.8266275336343,
        "biking": 119.06161471543945,
        "eBiking": 0.0,
        "winterHiking": 392.30000000000007,
        "snowshoeTrekking": 470.7,
        "mountainBiking": 128.25145528737627,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 148938098,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-08-03T18:27:47.196664",
      "modifiedAt": "2026-08-03T18:28:22.068280",
      "name": "260724 Sursee Buholz Ostergau",
      "type": "normal",
      "public": true,
      "userdate": "2026-07-24",
      "meta": {
        "length": 42943.99103686336,
        "totalup": 1066.4002380371094,
        "totaldown": 1065.1002502441406,
        "elemin": 498.79998779296875,
        "elemax": 699.7999877929688,
        "walking": 672.9899505175213,
        "biking": 230.0965958375281,
        "eBiking": 0.0,
        "winterHiking": 840.8000000000002,
        "snowshoeTrekking": 1009.7000000000002,
        "mountainBiking": 281.9491607878554,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1511621743,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2026-04-23T09:57:52.112171",
      "modifiedAt": "2026-08-10T19:53:07.389582",
      "name": "260423 Sursee Dierikon",
      "type": "normal",
      "public": true,
      "userdate": "2026-04-23",
      "meta": {
        "length": 27589.23193780243,
        "totalup": 366.1000671386719,
        "totaldown": 454.8000793457031,
        "elemin": 417.0,
        "elemax": 580.5,
        "walking": 411.1410424890481,
        "biking": 109.52803486455227,
        "eBiking": 0.0,
        "winterHiking": 513.9,
        "snowshoeTrekking": 616.5000000000001,
        "mountainBiking": 132.54786345142233,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 1948565972,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-08-07T17:08:58.214612",
      "modifiedAt": "2026-08-07T17:09:59.437008",
      "name": "260807 Livigno St Moritz",
      "type": "normal",
      "public": true,
      "userdate": "2026-08-07",
      "meta": {
        "length": 68563.34452581406,
        "totalup": 2594.1990356445312,
        "totaldown": 2695.0990600585938,
        "elemin": 1013.4,
        "elemax": 2485.6,
        "walking": 1264.6870597488755,
        "biking": 381.1739334906488,
        "eBiking": 0.0,
        "winterHiking": 1580.9,
        "snowshoeTrekking": 1897.0,
        "mountainBiking": 435.8906186851676,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1935230968,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-08-08T17:01:06.692839",
      "modifiedAt": "2026-08-08T17:02:10.317530",
      "name": "260808 Cinous-chel Scuol",
      "type": "normal",
      "public": true,
      "userdate": "2026-08-08",
      "meta": {
        "length": 42101.35882163048,
        "totalup": 865.6007080078125,
        "totaldown": 1211.4007568359375,
        "elemin": 1280.5,
        "elemax": 1709.1,
        "walking": 654.4985675860801,
        "biking": 211.3946893859275,
        "eBiking": 0.0,
        "winterHiking": 818.1,
        "snowshoeTrekking": 981.7,
        "mountainBiking": 255.64746969451514,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 864273435,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-08-07T17:10:32.594341",
      "modifiedAt": "2026-08-07T17:11:25.038827",
      "name": "260806 StMaria Livigno",
      "type": "normal",
      "public": true,
      "userdate": "2026-08-06",
      "meta": {
        "length": 46566.74187707901,
        "totalup": 1574.7999267578125,
        "totaldown": 1083.2999267578125,
        "elemin": 1373.7,
        "elemax": 2295.4,
        "walking": 782.7733943145987,
        "biking": 316.6699817525981,
        "eBiking": 0.0,
        "winterHiking": 978.5,
        "snowshoeTrekking": 1174.2,
        "mountainBiking": 362.74765749683667,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 556891858,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-08-05T20:10:29.018935",
      "modifiedAt": "2026-08-05T20:11:38.735657",
      "name": "260805 Zernez Sta Maria",
      "type": "normal",
      "public": true,
      "userdate": "2026-08-05",
      "meta": {
        "length": 61886.81643843651,
        "totalup": 2115.20068359375,
        "totaldown": 2211.0006103515625,
        "elemin": 1338.4,
        "elemax": 2534.6,
        "walking": 1038.4149480998265,
        "biking": 401.60316446700494,
        "eBiking": 0.0,
        "winterHiking": 1298.0,
        "snowshoeTrekking": 1557.6,
        "mountainBiking": 491.48909451785465,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1697562173,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2026-07-11T17:02:14.187061",
      "modifiedAt": "2026-07-11T21:07:43.247310",
      "name": "260711 Sursee Beckenried",
      "type": "normal",
      "public": true,
      "userdate": "2026-07-11",
      "meta": {
        "length": 115934.81843480002,
        "totalup": 917.2514343261719,
        "totaldown": 917.3292541503906,
        "elemin": 426.3,
        "elemax": 581.2,
        "walking": 0.0,
        "biking": 424.2724533210421,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 554562830,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-05-22T05:55:17.892847",
      "modifiedAt": "2026-05-22T05:56:31.296066",
      "name": "260521 Dierikon Sursee",
      "type": "normal",
      "public": true,
      "userdate": "2026-05-21",
      "meta": {
        "length": 35427.45900559425,
        "totalup": 635.999755859375,
        "totaldown": 548.5997619628906,
        "elemin": 416.9,
        "elemax": 777.3,
        "walking": 536.7607169222202,
        "biking": 170.35113642080447,
        "eBiking": 0.0,
        "winterHiking": 671.0,
        "snowshoeTrekking": 805.1,
        "mountainBiking": 214.03409766426594,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 2064543785,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-05-22T05:56:47.786714",
      "modifiedAt": "2026-05-22T05:57:43.024368",
      "name": "260521 Sursee Dierikon",
      "type": "normal",
      "public": true,
      "userdate": "2026-05-21",
      "meta": {
        "length": 27236.082872390747,
        "totalup": 418.8000793457031,
        "totaldown": 506.3000793457031,
        "elemin": 416.6,
        "elemax": 750.0,
        "walking": 409.19723940525023,
        "biking": 119.38438616566769,
        "eBiking": 0.0,
        "winterHiking": 511.5,
        "snowshoeTrekking": 613.8,
        "mountainBiking": 142.65759102347303,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1127746845,
      "filter": { "id": 77273, "name": "Plan" },
      "createdAt": "2026-04-26T11:47:32.815029",
      "modifiedAt": "2026-04-26T11:47:32.815029",
      "name": "Alpgschwänd ab Fräki",
      "type": "normal",
      "public": false,
      "userdate": "2026-04-26",
      "meta": {
        "length": 1899.14748609066,
        "totalup": 11.02099609375,
        "totaldown": 211.4281005859375,
        "elemin": 1208.8,
        "elemax": 1418.3,
        "walking": 30.54978203107243,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 492056208,
      "filter": { "id": 77273, "name": "Plan" },
      "createdAt": "2026-04-26T11:46:35.770314",
      "modifiedAt": "2026-04-26T11:46:35.770314",
      "name": "Alpgschwänd direkt",
      "type": "normal",
      "public": false,
      "userdate": "2026-04-26",
      "meta": {
        "length": 2234.136508822441,
        "totalup": 454.14630126953125,
        "totaldown": 0.0,
        "elemin": 763.9,
        "elemax": 1218.1,
        "walking": 74.94492710026377,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 978439800,
      "filter": { "id": 77273, "name": "Plan" },
      "createdAt": "2026-04-26T11:45:37.786908",
      "modifiedAt": "2026-04-26T11:45:37.786908",
      "name": "Alpgschwänd direkt Steinibach",
      "type": "normal",
      "public": false,
      "userdate": "2026-04-26",
      "meta": {
        "length": 2612.398955345154,
        "totalup": 458.075927734375,
        "totaldown": 2.52001953125,
        "elemin": 763.7,
        "elemax": 1219.3,
        "walking": 80.55716214499505,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1502539903,
      "filter": { "id": 77273, "name": "Plan" },
      "createdAt": "2026-04-26T11:44:17.972008",
      "modifiedAt": "2026-04-26T11:44:27.078210",
      "name": "Alpgschwänd Rundweg Schönenboden",
      "type": "normal",
      "public": false,
      "userdate": "2026-04-26",
      "meta": {
        "length": 5675.216029196978,
        "totalup": 580.7715454101562,
        "totaldown": 127.7496337890625,
        "elemin": 764.8,
        "elemax": 1311.0,
        "walking": 131.9929656595961,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1392864726,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-04-13T20:43:05.204992",
      "modifiedAt": "2026-04-15T20:35:22.864279",
      "name": "240413 Sempachersee",
      "type": "normal",
      "public": true,
      "userdate": "2024-04-13",
      "meta": {
        "length": 47018.45632505554,
        "totalup": 928.6998901367188,
        "totaldown": 929.1998901367188,
        "elemin": 491.6999816894531,
        "elemax": 792.5999755859375,
        "walking": 711.761554666273,
        "biking": 309.02018347563677,
        "eBiking": 0.0,
        "winterHiking": 890.0999999999999,
        "snowshoeTrekking": 1067.5000000000002,
        "mountainBiking": 287.19453325265425,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 726221900,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-07-05T21:22:40.929064",
      "modifiedAt": "2026-04-15T20:35:07.425038",
      "name": "230706 Dierikon",
      "type": "normal",
      "public": true,
      "userdate": "2023-07-06",
      "meta": {
        "length": 31849.46009229253,
        "totalup": 490.69989013671875,
        "totaldown": 578.7998962402344,
        "elemin": 417.8999938964844,
        "elemax": 749.0999755859375,
        "walking": 471.04274744838983,
        "biking": 176.29752632319784,
        "eBiking": 0.0,
        "winterHiking": 588.7000000000002,
        "snowshoeTrekking": 706.6999999999999,
        "mountainBiking": 164.82557345324898,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 631781668,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-06-10T09:16:47.249406",
      "modifiedAt": "2026-04-15T20:34:54.971545",
      "name": "230610 Ahorn",
      "type": "normal",
      "public": true,
      "userdate": "2023-06-10",
      "meta": {
        "length": 86498.17499514208,
        "totalup": 2533.2001342773438,
        "totaldown": 2532.7001342773438,
        "elemin": 498.8999938964844,
        "elemax": 1404.7999877929688,
        "walking": 1415.088756250579,
        "biking": 633.1693506295622,
        "eBiking": 0.0,
        "winterHiking": 1768.7,
        "snowshoeTrekking": 2123.2000000000007,
        "mountainBiking": 597.1631691677682,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6544788,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-04-03T14:34:13.053847",
      "modifiedAt": "2026-04-15T20:33:21.862665",
      "name": "200403 Böhler Wiliberg",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-03",
      "meta": {
        "length": 55685.16764367128,
        "totalup": 1253.5000610351562,
        "totaldown": 1253.5000610351562,
        "elemin": 432.3999938964844,
        "elemax": 781.8999938964844,
        "walking": 864.9380777905194,
        "biking": 414.53115137573076,
        "eBiking": 0.0,
        "winterHiking": 1081.3000000000002,
        "snowshoeTrekking": 1297.4000000000003,
        "mountainBiking": 337.95909116816176,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1077675322,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-07T11:38:46.766410",
      "modifiedAt": "2026-04-15T20:30:00.066925",
      "name": "170728 Rothorn Arosa",
      "type": "normal",
      "public": true,
      "userdate": "2017-07-28",
      "meta": {
        "length": 10315.028778787126,
        "totalup": 68.69992065429688,
        "totaldown": 1091.0999145507812,
        "elemin": 1833.0,
        "elemax": 2855.699981689453,
        "walking": 174.03119366151435,
        "biking": 29.69049577274024,
        "eBiking": 0.0,
        "winterHiking": 217.5,
        "snowshoeTrekking": 261.0,
        "mountainBiking": 28.575965798312623,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1851716,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2026-04-15T20:29:26.953266",
      "name": "140923 Rigi",
      "type": "normal",
      "public": true,
      "userdate": "2014-09-23",
      "meta": {
        "length": 25814.889022174182,
        "totalup": 1333.0999145507812,
        "totaldown": 1386.6999206542969,
        "elemin": 435.29998779296875,
        "elemax": 1616.7999877929688,
        "walking": 490.1626703712375,
        "biking": 218.58487712008252,
        "eBiking": 0.0,
        "winterHiking": 612.7,
        "snowshoeTrekking": 735.2,
        "mountainBiking": 247.59452014167078,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 364723802,
      "filter": { "id": 94631, "name": "Joggedijogg" },
      "createdAt": "2026-01-03T22:06:03.326597",
      "modifiedAt": "2026-04-15T19:48:06.022843",
      "name": "om de See",
      "type": "normal",
      "public": false,
      "userdate": "2026-01-03",
      "meta": {
        "length": 19394.765613526106,
        "totalup": 74.7271728515625,
        "totaldown": 74.79449462890625,
        "elemin": 503.7,
        "elemax": 519.4,
        "walking": 277.65289535748065,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 211163361,
      "filter": { "id": 94631, "name": "Joggedijogg" },
      "createdAt": "2026-03-29T04:25:46.686954",
      "modifiedAt": "2026-04-15T19:47:52.066636",
      "name": "Tour 29.03.2026 06:21",
      "type": "normal",
      "public": false,
      "userdate": "2026-03-29",
      "meta": {
        "length": 30741.504928410053,
        "totalup": 215.4240356445302,
        "totaldown": 214.48867187499894,
        "elemin": 487.3,
        "elemax": 542.9,
        "walking": 443.8636971656523,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 169850877,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-01-03T17:31:23.103048",
      "modifiedAt": "2026-04-15T19:47:29.669136",
      "name": "260103 Rickenbach Büron",
      "type": "normal",
      "public": true,
      "userdate": "2026-01-03",
      "meta": {
        "length": 10651.010705471039,
        "totalup": 220.10638427734375,
        "totaldown": 443.0063781738281,
        "elemin": 491.3,
        "elemax": 854.7,
        "walking": 163.44802874258065,
        "biking": 53.49389447626368,
        "eBiking": 0.0,
        "winterHiking": 206.0,
        "snowshoeTrekking": 246.79999999999995,
        "mountainBiking": 60.78285962639803,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 986251993,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2026-01-01T20:33:12.479863",
      "modifiedAt": "2026-04-15T19:46:17.563692",
      "name": "260101 Dottenberg",
      "type": "normal",
      "public": true,
      "userdate": "2026-01-01",
      "meta": {
        "length": 5727.67793738842,
        "totalup": 224.075927734375,
        "totaldown": 224.157958984375,
        "elemin": 531.7,
        "elemax": 732.9,
        "walking": 96.7739825660379,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 5001558,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-12-31T14:53:49.034314",
      "modifiedAt": "2026-04-15T19:19:09.929115",
      "name": "251231 Gschweich",
      "type": "normal",
      "public": true,
      "userdate": "2025-12-31",
      "meta": {
        "length": 7175.273958435875,
        "totalup": 196.47006225585938,
        "totaldown": 196.47006225585938,
        "elemin": 702.1799926757812,
        "elemax": 830.8599853515625,
        "walking": 113.27082224091474,
        "biking": 42.82966400977223,
        "eBiking": 0.0,
        "winterHiking": 141.60000000000002,
        "snowshoeTrekking": 169.8,
        "mountainBiking": 48.57646199869174,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 917102712,
      "filter": { "id": 94631, "name": "Joggedijogg" },
      "createdAt": "2026-01-03T22:18:54.459316",
      "modifiedAt": "2026-04-15T19:14:29.162014",
      "name": "17k Huprächtigen",
      "type": "normal",
      "public": false,
      "userdate": "2026-01-03",
      "meta": {
        "length": 17024.860632419586,
        "totalup": 237.71493530273438,
        "totaldown": 238.35888671875,
        "elemin": 503.3,
        "elemax": 685.4,
        "walking": 252.15300673946518,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1765452804,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2026-04-15T18:55:35.679256",
      "modifiedAt": "2026-04-15T18:57:10.421058",
      "name": "260411 Sempach Sändertrail",
      "type": "normal",
      "public": true,
      "userdate": "2026-04-11",
      "meta": {
        "length": 32074.07097572113,
        "totalup": 670.4499999999985,
        "totaldown": 676.7699999999983,
        "elemin": 504.44,
        "elemax": 807.88,
        "walking": 488.2943180519129,
        "biking": 158.5504692330708,
        "eBiking": 0.0,
        "winterHiking": 610.1,
        "snowshoeTrekking": 732.4000000000002,
        "mountainBiking": 196.34903480193748,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1341171378,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-12-01T15:26:44.535422",
      "modifiedAt": "2025-04-30T19:46:07.358860",
      "name": "241201 Guetzlirondi",
      "type": "normal",
      "public": true,
      "userdate": "2024-12-01",
      "meta": {
        "length": 31118.316936763396,
        "totalup": 516.5001953125,
        "totaldown": 516.1001892089844,
        "elemin": 486.1999816894531,
        "elemax": 596.3999938964844,
        "walking": 465.3039460397449,
        "biking": 182.41028371807826,
        "eBiking": 0.0,
        "winterHiking": 581.8,
        "snowshoeTrekking": 697.6999999999999,
        "mountainBiking": 170.3099261794939,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 3678936,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2017-07-16T16:19:14.895778",
      "modifiedAt": "2025-10-29T15:24:34.714058",
      "name": "170716 Fräkmünt Renggpass",
      "type": "normal",
      "public": true,
      "userdate": "2017-07-16",
      "meta": {
        "length": 38351.66141592935,
        "totalup": 1313.300048828125,
        "totaldown": 1313.4000549316406,
        "elemin": 434.8999938964844,
        "elemax": 1446.7999877929688,
        "walking": 653.4296036924201,
        "biking": 266.30171752832376,
        "eBiking": 0.0,
        "winterHiking": 816.8,
        "snowshoeTrekking": 980.3000000000001,
        "mountainBiking": 300.8219364640307,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7146534,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-29T15:16:00.414902",
      "name": "210718 Postautotour Lenzerheide Thusis",
      "type": "normal",
      "public": true,
      "userdate": "2021-07-18",
      "meta": {
        "length": 19978.943461129882,
        "totalup": 540.4998168945312,
        "totaldown": 1354.8998107910156,
        "elemin": 663.0,
        "elemax": 1527.5,
        "walking": 358.37335501931824,
        "biking": 129.801692494755,
        "eBiking": 0.0,
        "winterHiking": 448.2000000000001,
        "snowshoeTrekking": 537.6000000000003,
        "mountainBiking": 114.32341198530301,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 523944084,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-09-14T15:28:10.040504",
      "modifiedAt": "2025-09-14T15:28:10.040504",
      "name": "250914 Vier Seen Wanderung",
      "type": "normal",
      "public": true,
      "userdate": "2025-09-14",
      "meta": {
        "length": 12271.03483980894,
        "totalup": 656.7081298828125,
        "totaldown": 376.12890625,
        "elemin": 1819.6,
        "elemax": 2324.2,
        "walking": 232.9023940538157,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1203432788,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-07T11:59:05.409443",
      "modifiedAt": "2025-10-24T20:45:40.559004",
      "name": "170727 Scalottas Churwalden",
      "type": "normal",
      "public": true,
      "userdate": "2017-07-27",
      "meta": {
        "length": 10741.350273370743,
        "totalup": 408.4998779296875,
        "totaldown": 1201.699951171875,
        "elemin": 1237.6,
        "elemax": 2322.2,
        "walking": 191.81970962750202,
        "biking": 38.17780843575005,
        "eBiking": 0.0,
        "winterHiking": 239.8,
        "snowshoeTrekking": 287.7,
        "mountainBiking": 32.60007760883113,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 582939839,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-07T11:33:58.489232",
      "modifiedAt": "2025-10-26T18:56:43.694850",
      "name": "180803 Jakobshorn Davos",
      "type": "normal",
      "public": true,
      "userdate": "2018-08-03",
      "meta": {
        "length": 17624.44254603982,
        "totalup": 188.7003173828125,
        "totaldown": 1216.3004150390625,
        "elemin": 1532.1,
        "elemax": 2563.4,
        "walking": 282.6713223306743,
        "biking": 78.87746868438188,
        "eBiking": 0.0,
        "winterHiking": 353.3,
        "snowshoeTrekking": 424.0,
        "mountainBiking": 68.23975283289111,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 4494757,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2018-06-17T16:22:23.121527",
      "modifiedAt": "2025-09-30T20:42:18.890368",
      "name": "180616 Rigi Luzern",
      "type": "normal",
      "public": true,
      "userdate": "2018-06-16",
      "meta": {
        "length": 52423.03497106582,
        "totalup": 1777.6695251464844,
        "totaldown": 1851.6695251464844,
        "elemin": 415.0,
        "elemax": 1797.0,
        "walking": 895.4215137159,
        "biking": 439.4746322917,
        "eBiking": 0.0,
        "winterHiking": 1119.3,
        "snowshoeTrekking": 1343.1,
        "mountainBiking": 392.61036113680024,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 304260238,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-09-07T17:02:09.848165",
      "modifiedAt": "2025-09-07T19:02:12.333533",
      "name": "250906 Pazolastock Tomasee",
      "type": "normal",
      "public": true,
      "userdate": "2025-09-07",
      "meta": {
        "length": 13716.52396582067,
        "totalup": 976.672607421875,
        "totaldown": 976.47265625,
        "elemin": 1979.7,
        "elemax": 2740.8,
        "walking": 307.85631075177986,
        "biking": 122.13240777136808,
        "eBiking": 0.0,
        "winterHiking": 400.1,
        "snowshoeTrekking": 480.1,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 3938694,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2017-09-24T16:03:11.846566",
      "modifiedAt": "2025-09-30T20:44:55.879089",
      "name": "170924 Renggpass Mueterschwandenberg",
      "type": "normal",
      "public": true,
      "userdate": "2017-09-24",
      "meta": {
        "length": 31311.81185054779,
        "totalup": 1040.2000122070312,
        "totaldown": 1040.5,
        "elemin": 434.0,
        "elemax": 884.5,
        "walking": 523.9604593397198,
        "biking": 195.5095429776347,
        "eBiking": 0.0,
        "winterHiking": 655.0,
        "snowshoeTrekking": 785.9,
        "mountainBiking": 257.7171881189515,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1633314391,
      "filter": { "id": 79387, "name": "Schneeschuh" },
      "createdAt": "2022-02-12T15:41:01.622562",
      "modifiedAt": "2025-10-26T19:12:05.715935",
      "name": "220212 Stotzige Firsten",
      "type": "normal",
      "public": true,
      "userdate": "2022-02-12",
      "meta": {
        "length": 10848.066093608737,
        "totalup": 1010.199951171875,
        "totaldown": 1010.199951171875,
        "elemin": 1545.2,
        "elemax": 2537.2,
        "walking": 286.9,
        "biking": 113.6,
        "eBiking": 0.0,
        "winterHiking": 379.65328925376525,
        "snowshoeTrekking": 455.5839471045184,
        "mountainBiking": 113.49480301226387,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "snowshoe_trekking"
      }
    },
    {
      "id": 1997221957,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-09-22T19:35:25.376946",
      "modifiedAt": "2025-10-26T19:23:38.531066",
      "name": "240920 Monte Arbostora",
      "type": "normal",
      "public": true,
      "userdate": "2024-09-20",
      "meta": {
        "length": 33419.78962761164,
        "totalup": 1088.3127746582031,
        "totaldown": 1088.3127746582031,
        "elemin": 272.0,
        "elemax": 803.0,
        "walking": 550.458784198319,
        "biking": 312.5719358864158,
        "eBiking": 0.0,
        "winterHiking": 688.1,
        "snowshoeTrekking": 825.7,
        "mountainBiking": 275.2882103370458,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1930885063,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-07-02T19:13:33.058408",
      "modifiedAt": "2025-10-26T19:11:38.875393",
      "name": "220702 Horben",
      "type": "normal",
      "public": true,
      "userdate": "2022-07-02",
      "meta": {
        "length": 69714.58316747844,
        "totalup": 1565.9438781738281,
        "totaldown": 1565.9438781738281,
        "elemin": 450.8,
        "elemax": 865.0,
        "walking": 1068.7988781678241,
        "biking": 481.6729112243,
        "eBiking": 0.0,
        "winterHiking": 1346.9,
        "snowshoeTrekking": 1616.2,
        "mountainBiking": 456.1917151597406,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 5540913,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2019-06-02T19:19:10.900402",
      "modifiedAt": "2025-10-26T18:56:59.573171",
      "name": "190531 Ettiswil Santenberg",
      "type": "normal",
      "public": true,
      "userdate": "2019-05-31",
      "meta": {
        "length": 48924.38580647088,
        "totalup": 829.8999938964844,
        "totaldown": 829.9999694824219,
        "elemin": 481.2,
        "elemax": 700.1,
        "walking": 724.7,
        "biking": 312.6,
        "eBiking": 0.0,
        "winterHiking": 905.9,
        "snowshoeTrekking": 1087.1,
        "mountainBiking": 283.7261978408589,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 3988323,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2017-10-11T17:03:34.025531",
      "modifiedAt": "2025-09-30T20:45:11.699753",
      "name": "171011 Sursee Neudorf Rickenbach",
      "type": "normal",
      "public": true,
      "userdate": "2017-10-11",
      "meta": {
        "length": 34823.942865014076,
        "totalup": 872.4109191894531,
        "totaldown": 872.4109191894531,
        "elemin": 506.0,
        "elemax": 854.3,
        "walking": 527.2850265428904,
        "biking": 173.8402380199153,
        "eBiking": 0.0,
        "winterHiking": 659.1,
        "snowshoeTrekking": 790.9,
        "mountainBiking": 236.06465991207307,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 3957752,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2017-10-01T19:32:47.943203",
      "modifiedAt": "2025-09-30T20:45:04.755548",
      "name": "171001 Engelberg Sarnen",
      "type": "normal",
      "public": true,
      "userdate": "2017-10-01",
      "meta": {
        "length": 45547.26396390796,
        "totalup": 1752.8981323242188,
        "totaldown": 2279.298095703125,
        "elemin": 465.4,
        "elemax": 2208.1,
        "walking": 780.8542802475744,
        "biking": 253.88335215227377,
        "eBiking": 0.0,
        "winterHiking": 976.1,
        "snowshoeTrekking": 1171.3,
        "mountainBiking": 311.80003733197276,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 2075892511,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-09-03T16:17:02.631947",
      "modifiedAt": "2025-10-26T19:07:48.940049",
      "name": "200903 Turren Eiseesattel",
      "type": "normal",
      "public": true,
      "userdate": "2020-09-03",
      "meta": {
        "length": 41285.1298905015,
        "totalup": 1820.9000244140625,
        "totaldown": 2860.499969482422,
        "elemin": 483.3,
        "elemax": 2202.3,
        "walking": 806.8,
        "biking": 295.2,
        "eBiking": 0.0,
        "winterHiking": 1008.5,
        "snowshoeTrekking": 1210.2,
        "mountainBiking": 284.2998223128832,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1078831370,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-09-08T19:40:44.477603",
      "modifiedAt": "2025-10-26T19:07:31.226269",
      "name": "200909 Brunnen Chinzig Flüelen",
      "type": "normal",
      "public": true,
      "userdate": "2020-09-09",
      "meta": {
        "length": 49410.461344629526,
        "totalup": 1932.0076599121094,
        "totaldown": 1932.4076538085938,
        "elemin": 431.0,
        "elemax": 2073.2,
        "walking": 878.3,
        "biking": 443.4,
        "eBiking": 0.0,
        "winterHiking": 1097.9,
        "snowshoeTrekking": 1317.4,
        "mountainBiking": 433.2774413476513,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 331336249,
      "filter": { "id": 79387, "name": "Schneeschuh" },
      "createdAt": "2020-12-29T16:06:31.910816",
      "modifiedAt": "2025-10-26T19:10:18.881621",
      "name": "201229 Brisenhuis",
      "type": "normal",
      "public": true,
      "userdate": "2020-12-29",
      "meta": {
        "length": 8976.051706702525,
        "totalup": 645.6000366210938,
        "totaldown": 644.1000366210938,
        "elemin": 1154.5999755859375,
        "elemax": 1753.1999816894531,
        "walking": 204.85671641926965,
        "biking": 96.79025307573194,
        "eBiking": 0.0,
        "winterHiking": 256.1,
        "snowshoeTrekking": 307.3,
        "mountainBiking": 94.98182004322958,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "snowshoe_trekking"
      }
    },
    {
      "id": 32390169,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-10-18T21:43:03.725664",
      "modifiedAt": "2025-10-26T19:09:59.159454",
      "name": "201019 Olten Froburg Homberg",
      "type": "normal",
      "public": true,
      "userdate": "2020-10-19",
      "meta": {
        "length": 36135.22476904094,
        "totalup": 1509.9536743164062,
        "totaldown": 1509.6536865234375,
        "elemin": 398.8,
        "elemax": 936.5,
        "walking": 643.0,
        "biking": 317.8,
        "eBiking": 0.0,
        "winterHiking": 803.8,
        "snowshoeTrekking": 964.5,
        "mountainBiking": 312.26214828702643,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7821819,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-08-20T16:27:03.526023",
      "modifiedAt": "2025-10-26T19:07:17.567935",
      "name": "200820 Jochpass Giswil",
      "type": "normal",
      "public": true,
      "userdate": "2020-08-20",
      "meta": {
        "length": 34983.448656056076,
        "totalup": 1089.0999755859375,
        "totaldown": 2812.0000610351562,
        "elemin": 483.3,
        "elemax": 2254.6,
        "walking": 667.6,
        "biking": 257.9,
        "eBiking": 0.0,
        "winterHiking": 834.5,
        "snowshoeTrekking": 1001.4,
        "mountainBiking": 224.81651609761326,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6900795,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-05-22T21:35:51.271674",
      "modifiedAt": "2025-10-26T19:05:56.553419",
      "name": "200521 Marbach",
      "type": "normal",
      "public": true,
      "userdate": "2020-05-21",
      "meta": {
        "length": 21920.643295913935,
        "totalup": 980.199951171875,
        "totaldown": 979.4999389648438,
        "elemin": 830.0,
        "elemax": 1532.4,
        "walking": 397.1,
        "biking": 218.1,
        "eBiking": 0.0,
        "winterHiking": 496.4,
        "snowshoeTrekking": 595.7,
        "mountainBiking": 203.99230210916346,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6684572,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-04-23T20:31:22.666095",
      "modifiedAt": "2025-10-26T19:02:19.479586",
      "name": "200423 Gschweich Lätte",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-23",
      "meta": {
        "length": 66957.96570517123,
        "totalup": 1107.8741455078107,
        "totaldown": 1107.8741455078107,
        "elemin": 456.5,
        "elemax": 836.8,
        "walking": 1019.0,
        "biking": 464.5,
        "eBiking": 0.0,
        "winterHiking": 1273.8,
        "snowshoeTrekking": 1528.5,
        "mountainBiking": 382.0054818058524,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6614295,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-04-13T17:23:38.151582",
      "modifiedAt": "2025-10-26T19:02:01.578155",
      "name": "200413 Hildisrieden Vogelmoos",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-13",
      "meta": {
        "length": 43049.15013822913,
        "totalup": 815.3428649902344,
        "totaldown": 815.5428466796875,
        "elemin": 505.9,
        "elemax": 806.4,
        "walking": 661.2,
        "biking": 329.04058565294383,
        "eBiking": 0.0,
        "winterHiking": 826.5,
        "snowshoeTrekking": 991.8,
        "mountainBiking": 262.5806129445629,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 4494705,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2018-06-17T16:08:16.772938",
      "modifiedAt": "2025-09-30T20:43:34.729742",
      "name": "180617 Brunni Luzern",
      "type": "normal",
      "public": true,
      "userdate": "2018-06-17",
      "meta": {
        "length": 45209.45541065931,
        "totalup": 442.1997985839844,
        "totaldown": 1604.6997680664062,
        "elemin": 434.6,
        "elemax": 1866.0,
        "walking": 704.0886588422,
        "biking": 235.1792426749,
        "eBiking": 0.0,
        "winterHiking": 880.1,
        "snowshoeTrekking": 1056.1,
        "mountainBiking": 187.85589963080116,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 4363407,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2018-05-11T21:47:51.672125",
      "modifiedAt": "2025-09-30T20:45:23.365744",
      "name": "180511 Sursee St.Urban",
      "type": "normal",
      "public": true,
      "userdate": "2018-05-11",
      "meta": {
        "length": 65766.25267493725,
        "totalup": 1082.4542541503906,
        "totaldown": 1082.4542541503906,
        "elemin": 445.0,
        "elemax": 700.0,
        "walking": 993.0311623081493,
        "biking": 476.59050782308174,
        "eBiking": 0.0,
        "winterHiking": 1241.3,
        "snowshoeTrekking": 1489.5,
        "mountainBiking": 382.29428555875353,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 3812359,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2017-08-15T12:55:39.698606",
      "modifiedAt": "2025-09-30T20:44:47.936830",
      "name": "170815 Krienseregg Alp-Gschwänd",
      "type": "normal",
      "public": true,
      "userdate": "2017-08-15",
      "meta": {
        "length": 37557.75591787696,
        "totalup": 1468.0458374023438,
        "totaldown": 1468.0458374023438,
        "elemin": 435.4,
        "elemax": 1287.1,
        "walking": 643.1541900842021,
        "biking": 274.46280710315614,
        "eBiking": 0.0,
        "winterHiking": 803.9,
        "snowshoeTrekking": 964.7,
        "mountainBiking": 337.5372096748159,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 817288427,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-07-24T09:45:13.545143",
      "modifiedAt": "2025-09-30T20:45:46.603155",
      "name": "180731 Emmetten Panorama Tour",
      "type": "normal",
      "public": true,
      "userdate": "2018-07-31",
      "meta": {
        "length": 21587.411253750324,
        "totalup": 941.8999633789062,
        "totaldown": 942.2000122070312,
        "elemin": 754.6,
        "elemax": 1597.2,
        "walking": 370.5597409161,
        "biking": 199.4224540785,
        "eBiking": 0.0,
        "winterHiking": 463.2,
        "snowshoeTrekking": 555.8,
        "mountainBiking": 197.1106192046761,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 696798449,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-08-23T17:00:27.037727",
      "modifiedAt": "2025-09-30T20:40:06.424655",
      "name": "240823 Turren SörenbergRothorn Wilerhorn",
      "type": "normal",
      "public": true,
      "userdate": "2024-08-23",
      "meta": {
        "length": 41240.964509841055,
        "totalup": 2195.200317382812,
        "totaldown": 3242.000366210937,
        "elemin": 483.5,
        "elemax": 2346.9,
        "walking": 914.6830190273032,
        "biking": 274.65230804784585,
        "eBiking": 0.0,
        "winterHiking": 1143.4,
        "snowshoeTrekking": 1372.0,
        "mountainBiking": 261.56403274007886,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1415096878,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-07T11:36:42.535662",
      "modifiedAt": "2025-09-30T20:44:40.863932",
      "name": "170729 Welschtobel",
      "type": "normal",
      "public": true,
      "userdate": "2017-07-29",
      "meta": {
        "length": 20424.65297268331,
        "totalup": 825.199951171875,
        "totaldown": 1848.7999267578125,
        "elemin": 1617.6,
        "elemax": 2855.7,
        "walking": 412.1023611636463,
        "biking": 144.15019044982148,
        "eBiking": 0.0,
        "winterHiking": 515.1,
        "snowshoeTrekking": 618.2,
        "mountainBiking": 135.3987784863523,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1937177424,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-08-02T16:57:22.402458",
      "modifiedAt": "2025-10-26T19:24:48.402845",
      "name": "250802 Disentis Caischavedra-Sedrun",
      "type": "normal",
      "public": true,
      "userdate": "2025-08-02",
      "meta": {
        "length": 8456.031522423029,
        "totalup": 262.8001708984375,
        "totaldown": 683.7001953125,
        "elemin": 1434.7,
        "elemax": 1994.4,
        "walking": 165.3275343525348,
        "biking": 63.62539849555639,
        "eBiking": 0.0,
        "winterHiking": 206.7,
        "snowshoeTrekking": 248.0,
        "mountainBiking": 57.754211105760966,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 447841249,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-09-27T21:09:51.393343",
      "modifiedAt": "2025-10-26T19:22:09.401785",
      "name": "230930 Grimselpass Chaeserstatt",
      "type": "normal",
      "public": true,
      "userdate": "2023-09-30",
      "meta": {
        "length": 37778.315990149975,
        "totalup": 1092.76220703125,
        "totaldown": 1483.26220703125,
        "elemin": 1214.8,
        "elemax": 2237.9,
        "walking": 618.2021339892186,
        "biking": 312.0786975551898,
        "eBiking": 0.0,
        "winterHiking": 772.8,
        "snowshoeTrekking": 927.3,
        "mountainBiking": 280.9783119229135,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1306849511,
      "filter": { "id": 77273, "name": "Plan" },
      "createdAt": "2025-10-24T15:59:01.413036",
      "modifiedAt": "2025-10-24T16:05:08.660369",
      "name": "Fellilücke",
      "type": "normal",
      "public": false,
      "userdate": "2025-10-24",
      "meta": {
        "length": 13726.691439100276,
        "totalup": 1987.8000793457031,
        "totaldown": 131.2000732421875,
        "elemin": 707.2999877929688,
        "elemax": 2593.7999877929688,
        "walking": 474.31350524136354,
        "biking": 213.2763620825812,
        "eBiking": 0.0,
        "winterHiking": 494.1,
        "snowshoeTrekking": 592.9,
        "mountainBiking": 208.35711239250503,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1770115528,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-10-15T19:55:21.380470",
      "modifiedAt": "2025-10-19T11:25:18.194624",
      "name": "251018 Steimi 40gi",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-15",
      "meta": {
        "length": 6573.457089309581,
        "totalup": 110.063232421875,
        "totaldown": 661.6342468261719,
        "elemin": 473.1,
        "elemax": 1072.9,
        "walking": 114.21881026627095,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 979433070,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-06-07T16:04:34.880952",
      "modifiedAt": "2025-10-26T19:22:42.518913",
      "name": "240607 Yeti Testrunde",
      "type": "normal",
      "public": true,
      "userdate": "2024-06-07",
      "meta": {
        "length": 39278.698303282494,
        "totalup": 904.2193298339844,
        "totaldown": 904.0193481445312,
        "elemin": 492.5,
        "elemax": 739.8,
        "walking": 612.1458118030363,
        "biking": 276.6972918954365,
        "eBiking": 0.0,
        "winterHiking": 765.2,
        "snowshoeTrekking": 918.2,
        "mountainBiking": 262.4503480346163,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1557577349,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2025-10-08T18:10:00.990505",
      "modifiedAt": "2025-10-26T19:29:42.525020",
      "name": "251009 Colombier Lausanne",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-09",
      "meta": {
        "length": 88970.1648919245,
        "totalup": 853.199951171875,
        "totaldown": 870.3999633789062,
        "elemin": 373.1999816894531,
        "elemax": 543.2999877929688,
        "walking": 1293.988372538454,
        "biking": 336.61513514525126,
        "eBiking": 0.0,
        "winterHiking": 1617.5000000000002,
        "snowshoeTrekking": 1941.1999999999998,
        "mountainBiking": 415.6409807632666,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 1513633678,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2025-10-08T18:09:56.989020",
      "modifiedAt": "2025-10-26T19:29:30.109203",
      "name": "251008 Solothurn Colombier",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-08",
      "meta": {
        "length": 77295.80268091694,
        "totalup": 377.099609375,
        "totaldown": 351.29962158203125,
        "elemin": 427.29998779296875,
        "elemax": 469.5999755859375,
        "walking": 1112.5223501036212,
        "biking": 258.54591555454624,
        "eBiking": 0.0,
        "winterHiking": 1390.6999999999998,
        "snowshoeTrekking": 1668.6999999999998,
        "mountainBiking": 310.9284789230302,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 394549496,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2025-10-08T15:37:32.497180",
      "modifiedAt": "2025-10-26T19:29:17.679931",
      "name": "251007 Sursee Solothurn",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-07",
      "meta": {
        "length": 76476.65595244993,
        "totalup": 589.10009765625,
        "totaldown": 655.5000915527344,
        "elemin": 390.8999938964844,
        "elemax": 545.8999938964844,
        "walking": 1105.848789653187,
        "biking": 271.9150397189103,
        "eBiking": 0.0,
        "winterHiking": 1382.3,
        "snowshoeTrekking": 1658.8000000000002,
        "mountainBiking": 329.71568261187264,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 741585017,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-10-05T17:46:23.990698",
      "modifiedAt": "2025-10-26T19:25:25.228085",
      "name": "251003 Lauchernalp Leukerbad",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-03",
      "meta": {
        "length": 35855.56366622448,
        "totalup": 1410.20068359375,
        "totaldown": 2017.8006591796875,
        "elemin": 1298.3,
        "elemax": 2310.7,
        "walking": 647.4091560988151,
        "biking": 305.7533277579877,
        "eBiking": 0.0,
        "winterHiking": 809.3,
        "snowshoeTrekking": 971.1,
        "mountainBiking": 294.4051568759735,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 488408143,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-10-05T17:35:18.631197",
      "modifiedAt": "2025-10-26T19:26:01.744318",
      "name": "251005 Gemmi Frutigen",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-05",
      "meta": {
        "length": 30654.64146772027,
        "totalup": 281.60009765625,
        "totaldown": 1842.5001831054688,
        "elemin": 771.1,
        "elemax": 2340.1,
        "walking": 0.0,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 111.73533125498993,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 376532763,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-10-05T18:05:14.517058",
      "modifiedAt": "2025-10-26T19:25:36.516361",
      "name": "251004 Jeizinen Leuk",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-05",
      "meta": {
        "length": 18036.46375501156,
        "totalup": 102.300048828125,
        "totaldown": 1019.5001220703125,
        "elemin": 618.3,
        "elemax": 1543.3,
        "walking": 288.53276504010654,
        "biking": 71.82928948248035,
        "eBiking": 0.0,
        "winterHiking": 360.7,
        "snowshoeTrekking": 432.8,
        "mountainBiking": 62.422082654487916,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 2047307211,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-10-04T16:01:12.402683",
      "modifiedAt": "2025-10-26T19:25:49.618511",
      "name": "251004 Leukerbad Gampel",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-04",
      "meta": {
        "length": 27173.296978573955,
        "totalup": 435.35736083984375,
        "totaldown": 2110.606689453125,
        "elemin": 624.4,
        "elemax": 2312.0,
        "walking": 0.0,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 123.48862020826486,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 2011479176,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-09-22T19:37:11.402370",
      "modifiedAt": "2025-10-26T19:24:00.991010",
      "name": "240922 Monte Tamaro",
      "type": "normal",
      "public": true,
      "userdate": "2024-09-22",
      "meta": {
        "length": 39116.04225282371,
        "totalup": 1678.0001525878906,
        "totaldown": 1836.6001586914062,
        "elemin": 271.4,
        "elemax": 1890.2,
        "walking": 701.2262986677846,
        "biking": 357.6168891325209,
        "eBiking": 0.0,
        "winterHiking": 876.5,
        "snowshoeTrekking": 1051.8,
        "mountainBiking": 324.1342276164934,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 318124437,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-10-02T14:06:14.299695",
      "modifiedAt": "2025-10-02T14:06:33.809121",
      "name": "251002 Stöckalp Älggi Frutt",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-02",
      "meta": {
        "length": 16185.620297953486,
        "totalup": 1549.3424072265625,
        "totaldown": 696.49755859375,
        "elemin": 1073.6,
        "elemax": 2230.1,
        "walking": 393.76097954380697,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 179.20116566497126,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1353796196,
      "filter": { "id": 94631, "name": "Joggedijogg" },
      "createdAt": "2025-10-01T18:39:40.706746",
      "modifiedAt": "2025-10-01T18:39:40.706746",
      "name": "Longrun 2.10.2025 Bachi",
      "type": "normal",
      "public": false,
      "userdate": "2025-10-01",
      "meta": {
        "length": 33228.42845408377,
        "totalup": 642.5797729492188,
        "totaldown": 644.1249084472656,
        "elemin": 504.2,
        "elemax": 737.7,
        "walking": 0.0,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "no"
      }
    },
    {
      "id": 2081877597,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-09-27T21:13:54.690834",
      "modifiedAt": "2025-10-26T19:21:54.165542",
      "name": "231001 Chäserstatt_Trophy",
      "type": "normal",
      "public": true,
      "userdate": "2023-10-01",
      "meta": {
        "length": 45266.30219256878,
        "totalup": 1564.7227172851562,
        "totaldown": 2668.5227661132812,
        "elemin": 671.7,
        "elemax": 2564.3,
        "walking": 805.6118064747874,
        "biking": 383.0845887287184,
        "eBiking": 0.0,
        "winterHiking": 1007.0,
        "snowshoeTrekking": 1208.4,
        "mountainBiking": 342.3631235444461,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 669283109,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-09-30T18:57:28.772823",
      "modifiedAt": "2025-10-20T20:13:29.068225",
      "name": "250930 Meggerwald",
      "type": "normal",
      "public": true,
      "userdate": "2025-09-30",
      "meta": {
        "length": 21619.066141210107,
        "totalup": 819.6000061035156,
        "totaldown": 819.6999816894531,
        "elemin": 419.0,
        "elemax": 710.3999938964844,
        "walking": 370.3206763416815,
        "biking": 183.57197641059105,
        "eBiking": 0.0,
        "winterHiking": 462.9,
        "snowshoeTrekking": 555.5,
        "mountainBiking": 174.79101821432533,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 440412650,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-11-06T12:42:51.831905",
      "modifiedAt": "2025-10-26T19:24:14.017115",
      "name": "241106 Hergiswil Menzberg",
      "type": "normal",
      "public": true,
      "userdate": "2024-11-06",
      "meta": {
        "length": 63623.690398082064,
        "totalup": 1574.3680114746094,
        "totaldown": 1574.3680114746094,
        "elemin": 499.4,
        "elemax": 1088.7,
        "walking": 998.5091042097179,
        "biking": 458.35557752118626,
        "eBiking": 0.0,
        "winterHiking": 1248.1,
        "snowshoeTrekking": 1497.8,
        "mountainBiking": 437.5965148901167,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6236676,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2019-10-27T15:17:01.244098",
      "modifiedAt": "2025-10-26T19:01:34.594809",
      "name": "191027 Sempachersee",
      "type": "normal",
      "public": true,
      "userdate": "2019-10-27",
      "meta": {
        "length": 34967.402447097,
        "totalup": 591.9193725585938,
        "totaldown": 592.0193786621094,
        "elemin": 499.4,
        "elemax": 749.9,
        "walking": 507.6,
        "biking": 224.9,
        "eBiking": 0.0,
        "winterHiking": 634.5,
        "snowshoeTrekking": 761.4,
        "mountainBiking": 200.86817728778453,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 4396961,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2018-05-21T15:16:00.839507",
      "modifiedAt": "2025-09-30T20:45:38.463364",
      "name": "180521 Eigental Hüenerhubel",
      "type": "normal",
      "public": true,
      "userdate": "2018-05-21",
      "meta": {
        "length": 39601.83897936344,
        "totalup": 1334.0997619628906,
        "totaldown": 1336.999755859375,
        "elemin": 432.3,
        "elemax": 1552.9,
        "walking": 679.2045036916,
        "biking": 344.8934962747,
        "eBiking": 0.0,
        "winterHiking": 849.0,
        "snowshoeTrekking": 1018.8,
        "mountainBiking": 303.8877837565014,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 849640087,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-17T17:47:03.624244",
      "modifiedAt": "2025-10-26T19:10:32.914158",
      "name": "211017 Grindelwald First",
      "type": "normal",
      "public": true,
      "userdate": "2021-10-17",
      "meta": {
        "length": 26794.147426217794,
        "totalup": 1516.099853515625,
        "totaldown": 1516.099853515625,
        "elemin": 943.7,
        "elemax": 2279.8,
        "walking": 538.6,
        "biking": 231.4,
        "eBiking": 0.0,
        "winterHiking": 673.2,
        "snowshoeTrekking": 807.9,
        "mountainBiking": 261.2276400482277,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 390888146,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-29T15:36:22.750915",
      "modifiedAt": "2025-10-26T19:11:52.233844",
      "name": "211029 Fürenalp Erstfeld",
      "type": "normal",
      "public": true,
      "userdate": "2021-10-29",
      "meta": {
        "length": 20025.097983568907,
        "totalup": 729.6000366210938,
        "totaldown": 2098.2000122070312,
        "elemin": 465.1,
        "elemax": 2292.2,
        "walking": 414.6,
        "biking": 135.6,
        "eBiking": 0.0,
        "winterHiking": 518.2,
        "snowshoeTrekking": 621.9,
        "mountainBiking": 124.31291889404336,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1603175130,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-10-12T09:12:36.278582",
      "modifiedAt": "2025-10-26T19:30:17.822521",
      "name": "251011 Arnisee Sunniggrat",
      "type": "normal",
      "public": true,
      "userdate": "2025-10-11",
      "meta": {
        "length": 11138.981935804488,
        "totalup": 909.7999572753906,
        "totaldown": 911.5999450683594,
        "elemin": 1292.2999877929688,
        "elemax": 2096.0,
        "walking": 277.10072602799323,
        "biking": 98.20237279517941,
        "eBiking": 0.0,
        "winterHiking": 346.5,
        "snowshoeTrekking": 415.6,
        "mountainBiking": 96.79633419331397,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 347797161,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-07-13T17:26:50.516217",
      "modifiedAt": "2025-10-26T19:29:06.295127",
      "name": "250712/13 Passo delle Columbe",
      "type": "normal",
      "public": true,
      "userdate": "2025-07-12",
      "meta": {
        "length": 18232.3,
        "totalup": 687.0999999999992,
        "totaldown": 560.3999999999992,
        "elemin": 1790.3,
        "elemax": 2380.9,
        "walking": 305.90178400449895,
        "biking": 167.7748378277497,
        "eBiking": 0.0,
        "winterHiking": 382.4,
        "snowshoeTrekking": 458.9,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1521339886,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-06-23T18:33:34.064472",
      "modifiedAt": "2025-10-26T19:28:56.470535",
      "name": "250622 Triftsee",
      "type": "normal",
      "public": true,
      "userdate": "2025-06-22",
      "meta": {
        "length": 14483.6,
        "totalup": 1331.6000000000004,
        "totaldown": 1331.6000000000001,
        "elemin": 1009.2,
        "elemax": 1918.4,
        "walking": 393.6140606206691,
        "biking": 148.3357094673076,
        "eBiking": 0.0,
        "winterHiking": 492.0,
        "snowshoeTrekking": 590.4,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 908915273,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-06-08T20:54:22.468747",
      "modifiedAt": "2025-10-26T19:28:47.953168",
      "name": "250608 Fürstei",
      "type": "normal",
      "public": true,
      "userdate": "2025-06-08",
      "meta": {
        "length": 7767.3,
        "totalup": 666.7999999999993,
        "totaldown": 664.9999999999993,
        "elemin": 1539.9,
        "elemax": 2039.5,
        "walking": 199.89779076644302,
        "biking": 67.53613056735358,
        "eBiking": 0.0,
        "winterHiking": 249.9,
        "snowshoeTrekking": 299.8,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 858972923,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-11-16T15:08:27.980547",
      "modifiedAt": "2025-10-26T19:28:39.253728",
      "name": "241116 Lütholdsmatt Widderfeld",
      "type": "normal",
      "public": true,
      "userdate": "2024-11-16",
      "meta": {
        "length": 13423.7,
        "totalup": 1052.2000000000003,
        "totaldown": 1052.2000000000003,
        "elemin": 1126.3,
        "elemax": 2051.6,
        "walking": 319.7202806442716,
        "biking": 123.17139266468924,
        "eBiking": 0.0,
        "winterHiking": 399.7,
        "snowshoeTrekking": 479.6,
        "mountainBiking": 121.65539159915693,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1393404518,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-07-29T19:10:29.545947",
      "modifiedAt": "2025-10-26T19:28:05.977814",
      "name": "250729 Foodtrail Willisau",
      "type": "normal",
      "public": true,
      "userdate": "2025-07-29",
      "meta": {
        "length": 7573.3,
        "totalup": 131.6999999999996,
        "totaldown": 45.79999999999961,
        "elemin": 519.7,
        "elemax": 605.6,
        "walking": 114.24185498234873,
        "biking": 46.964141290209966,
        "eBiking": 0.0,
        "winterHiking": 142.8,
        "snowshoeTrekking": 171.4,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1995277192,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2025-07-29T19:08:15.730274",
      "modifiedAt": "2025-10-26T19:27:54.956655",
      "name": "250729 Willisau",
      "type": "normal",
      "public": true,
      "userdate": "2025-07-29",
      "meta": {
        "length": 36015.11936424645,
        "totalup": 250.30010986328125,
        "totaldown": 257.4001159667969,
        "elemin": 488.3999938964844,
        "elemax": 557.7999877929688,
        "walking": 517.8703253315297,
        "biking": 124.83660107026434,
        "eBiking": 0.0,
        "winterHiking": 647.5,
        "snowshoeTrekking": 777.2,
        "mountainBiking": 152.06210969847757,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "velo"
      }
    },
    {
      "id": 449118170,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-08-15T13:48:51.141177",
      "modifiedAt": "2025-10-26T19:27:40.341454",
      "name": "250809 Eigenthal Würzenegg",
      "type": "normal",
      "public": true,
      "userdate": "2025-08-09",
      "meta": {
        "length": 3105.6,
        "totalup": 167.4000000000002,
        "totaldown": 167.30000000000018,
        "elemin": 1016.9,
        "elemax": 1172.7,
        "walking": 62.83303962232697,
        "biking": 21.804397614579454,
        "eBiking": 0.0,
        "winterHiking": 78.5,
        "snowshoeTrekking": 94.2,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1714981849,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-11-10T15:32:32.759172",
      "modifiedAt": "2025-10-26T19:27:31.243878",
      "name": "241110 Marbachegg Kemmeriboden",
      "type": "normal",
      "public": true,
      "userdate": "2024-11-10",
      "meta": {
        "length": 8154.3,
        "totalup": 230.0999999999999,
        "totaldown": 722.5,
        "elemin": 975.6,
        "elemax": 1468.7,
        "walking": 147.36160097923542,
        "biking": 56.21542910941883,
        "eBiking": 0.0,
        "winterHiking": 184.2,
        "snowshoeTrekking": 221.0,
        "mountainBiking": 53.3492725868904,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 295737509,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-10-31T13:00:02.388409",
      "modifiedAt": "2025-10-26T19:27:20.209134",
      "name": "241031 Seebodenalp Rigi Scheidegg",
      "type": "normal",
      "public": true,
      "userdate": "2024-10-31",
      "meta": {
        "length": 12774.2,
        "totalup": 1265.7000000000003,
        "totaldown": 640.9000000000003,
        "elemin": 1017.1,
        "elemax": 1797.1,
        "walking": 330.99015162127773,
        "biking": 125.59335120108332,
        "eBiking": 0.0,
        "winterHiking": 413.7,
        "snowshoeTrekking": 496.5,
        "mountainBiking": 122.40742434273176,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1454016851,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-10-27T11:25:55.537763",
      "modifiedAt": "2025-10-26T19:27:12.244708",
      "name": "241026 St Ursanne Doubs",
      "type": "normal",
      "public": true,
      "userdate": "2024-10-27",
      "meta": {
        "length": 7106.8,
        "totalup": 249.70000000000005,
        "totaldown": 249.20000000000005,
        "elemin": 435.3,
        "elemax": 631.1,
        "walking": 123.03107281218814,
        "biking": 49.77724958856697,
        "eBiking": 0.0,
        "winterHiking": 153.8,
        "snowshoeTrekking": 184.5,
        "mountainBiking": 47.74587259187448,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 172785870,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-10-20T18:28:32.068023",
      "modifiedAt": "2025-10-26T19:27:04.663912",
      "name": "241020 Lüdernalp",
      "type": "normal",
      "public": true,
      "userdate": "2024-10-20",
      "meta": {
        "length": 8169.4,
        "totalup": 361.3999999999994,
        "totaldown": 361.5999999999992,
        "elemin": 1139.3,
        "elemax": 1321.5,
        "walking": 148.88746422844994,
        "biking": 67.56452480338523,
        "eBiking": 0.0,
        "winterHiking": 186.1,
        "snowshoeTrekking": 223.3,
        "mountainBiking": 64.32966364815267,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1680711912,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-10-16T15:02:24.818216",
      "modifiedAt": "2025-10-26T19:26:53.759059",
      "name": "241016 Pilatuskette",
      "type": "normal",
      "public": true,
      "userdate": "2024-10-16",
      "meta": {
        "length": 17757.4,
        "totalup": 1861.2999999999988,
        "totaldown": 1467.7999999999986,
        "elemin": 1016.1,
        "elemax": 2100.3,
        "walking": 495.40416218286356,
        "biking": 208.52223146220453,
        "eBiking": 0.0,
        "winterHiking": 619.3,
        "snowshoeTrekking": 743.1,
        "mountainBiking": 206.4768072386419,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1301705526,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-08-28T13:16:10.660477",
      "modifiedAt": "2025-10-26T19:26:40.849565",
      "name": "240823 Engelberg Aaschlucht",
      "type": "normal",
      "public": true,
      "userdate": "2024-08-28",
      "meta": {
        "length": 8475.9,
        "totalup": 40.60000000000002,
        "totaldown": 471.4000000000001,
        "elemin": 567.1,
        "elemax": 999.0,
        "walking": 126.27615155232039,
        "biking": 25.86366902247938,
        "eBiking": 0.0,
        "winterHiking": 157.8,
        "snowshoeTrekking": 189.4,
        "mountainBiking": 24.577108682322148,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1687221044,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-11-10T22:09:39.906210",
      "modifiedAt": "2025-10-26T19:26:31.424895",
      "name": "240726 Heiligkreuz",
      "type": "normal",
      "public": true,
      "userdate": "2024-07-26",
      "meta": {
        "length": 2465.5,
        "totalup": 107.20000000000005,
        "totaldown": 107.40000000000009,
        "elemin": 1081.2,
        "elemax": 1130.6,
        "walking": 44.3490427666486,
        "biking": 19.578363393984425,
        "eBiking": 0.0,
        "winterHiking": 55.4,
        "snowshoeTrekking": 66.5,
        "mountainBiking": 18.622318066652888,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 855664553,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-07-19T15:31:08.040106",
      "modifiedAt": "2025-10-26T19:26:19.426858",
      "name": "240719 4 Seen Wanderung",
      "type": "normal",
      "public": true,
      "userdate": "2024-07-19",
      "meta": {
        "length": 12858.7,
        "totalup": 741.0999999999995,
        "totaldown": 460.39999999999964,
        "elemin": 1819.6,
        "elemax": 2324.2,
        "walking": 253.5652838593496,
        "biking": 113.68611301550807,
        "eBiking": 0.0,
        "winterHiking": 317.0,
        "snowshoeTrekking": 380.3,
        "mountainBiking": 109.60682712318672,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 987100421,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-06-09T19:01:01.605149",
      "modifiedAt": "2025-10-26T19:26:10.369806",
      "name": "240815 Bad Zurzach Papa Moll",
      "type": "normal",
      "public": true,
      "userdate": "2024-08-15",
      "meta": {
        "length": 5263.9,
        "totalup": 60.29999999999984,
        "totaldown": 60.29999999999984,
        "elemin": 321.2,
        "elemax": 348.1,
        "walking": 77.80951298548426,
        "biking": 26.14690722224457,
        "eBiking": 0.0,
        "winterHiking": 97.3,
        "snowshoeTrekking": 116.7,
        "mountainBiking": 0.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 323039965,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-08-03T12:33:08.621553",
      "modifiedAt": "2025-10-26T19:25:11.406677",
      "name": "250803 Disentis Cuolm da Vi",
      "type": "normal",
      "public": true,
      "userdate": "2025-08-03",
      "meta": {
        "length": 12070.070594994351,
        "totalup": 197.306396484375,
        "totaldown": 1170.7064208984375,
        "elemin": 1218.1,
        "elemax": 2322.6,
        "walking": 208.6610486625233,
        "biking": 55.817338569891085,
        "eBiking": 0.0,
        "winterHiking": 260.8,
        "snowshoeTrekking": 313.0,
        "mountainBiking": 48.61107137758178,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1213871091,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-08-02T17:01:51.248041",
      "modifiedAt": "2025-10-26T19:24:59.760314",
      "name": "250802 Oberalppass Disentis",
      "type": "normal",
      "public": true,
      "userdate": "2025-08-02",
      "meta": {
        "length": 28318.016765281558,
        "totalup": 877.900390625,
        "totaldown": 1690.1004638671875,
        "elemin": 1199.2,
        "elemax": 2043.8,
        "walking": 493.45282795042516,
        "biking": 202.72928041678333,
        "eBiking": 0.0,
        "winterHiking": 616.8,
        "snowshoeTrekking": 740.2,
        "mountainBiking": 193.25303610799847,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 740593614,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-08-28T13:12:57.582844",
      "modifiedAt": "2025-10-26T19:24:35.004943",
      "name": "240828 Grimsel Sidelhorn",
      "type": "normal",
      "public": true,
      "userdate": "2024-08-28",
      "meta": {
        "length": 7648.753730535507,
        "totalup": 671.435302734375,
        "totaldown": 671.621826171875,
        "elemin": 2161.0,
        "elemax": 2761.0,
        "walking": 199.51876394879008,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 74.11449680120079,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1147938605,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-09-22T19:36:25.549810",
      "modifiedAt": "2025-10-26T19:23:47.198316",
      "name": "240921 Monte Generoso Mendrisio",
      "type": "normal",
      "public": true,
      "userdate": "2024-09-21",
      "meta": {
        "length": 27025.33321493864,
        "totalup": 940.1999206542969,
        "totaldown": 2185.399932861328,
        "elemin": 354.6,
        "elemax": 1608.0,
        "walking": 524.744447485574,
        "biking": 202.55999903217054,
        "eBiking": 0.0,
        "winterHiking": 655.9,
        "snowshoeTrekking": 787.1,
        "mountainBiking": 182.94464761945565,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 586048746,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-09-08T10:29:33.318800",
      "modifiedAt": "2025-10-26T19:23:26.746492",
      "name": "240906 Sursee Brugg",
      "type": "normal",
      "public": true,
      "userdate": "2024-09-07",
      "meta": {
        "length": 59050.16868290305,
        "totalup": 1088.8844299316406,
        "totaldown": 1262.7844543457031,
        "elemin": 331.6,
        "elemax": 836.2,
        "walking": 902.6024967865324,
        "biking": 401.45156548718984,
        "eBiking": 0.0,
        "winterHiking": 1128.3,
        "snowshoeTrekking": 1353.9,
        "mountainBiking": 339.84238514585746,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 818656831,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2024-07-06T13:03:12.274865",
      "modifiedAt": "2025-10-26T19:22:54.925263",
      "name": "240705 Alp Tschingla",
      "type": "normal",
      "public": true,
      "userdate": "2024-07-05",
      "meta": {
        "length": 11171.2,
        "totalup": 968.6,
        "totaldown": 968.6,
        "elemin": 848.0,
        "elemax": 1718.0,
        "walking": 289.62758303368383,
        "biking": 91.92465520608557,
        "eBiking": 0.0,
        "winterHiking": 362.0,
        "snowshoeTrekking": 434.4,
        "mountainBiking": 90.31899446230791,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 567666713,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2024-05-12T14:45:09.723920",
      "modifiedAt": "2025-10-26T19:22:31.123724",
      "name": "240512 Leidenberg Santenberg Lätte",
      "type": "normal",
      "public": true,
      "userdate": "2024-05-12",
      "meta": {
        "length": 38465.45384353399,
        "totalup": 843.9864807128906,
        "totaldown": 843.9864807128906,
        "elemin": 476.9,
        "elemax": 767.5,
        "walking": 594.6647146123539,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 245.80936839391117,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1433818927,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2023-09-28T19:26:10.469291",
      "modifiedAt": "2025-10-26T19:21:25.549884",
      "name": "230928 Arnigrat",
      "type": "normal",
      "public": true,
      "userdate": "2023-09-28",
      "meta": {
        "length": 13498.7,
        "totalup": 1528.9000000000005,
        "totaldown": 1528.9,
        "elemin": 859.9,
        "elemax": 2104.4,
        "walking": 423.0950126918782,
        "biking": 140.56658139347977,
        "eBiking": 0.0,
        "winterHiking": 528.9,
        "snowshoeTrekking": 634.6,
        "mountainBiking": 140.04503607933935,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 121870963,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2023-09-17T14:12:25.183213",
      "modifiedAt": "2025-10-26T19:21:00.501233",
      "name": "230917 Napf",
      "type": "normal",
      "public": true,
      "userdate": "2023-09-17",
      "meta": {
        "length": 6790.8,
        "totalup": 531.5999999999997,
        "totaldown": 531.5999999999997,
        "elemin": 968.3,
        "elemax": 1404.8,
        "walking": 163.3198236002289,
        "biking": 59.68682747451224,
        "eBiking": 0.0,
        "winterHiking": 204.1,
        "snowshoeTrekking": 245.0,
        "mountainBiking": 58.86683532847872,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1720718430,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2023-08-11T15:27:15.702256",
      "modifiedAt": "2025-10-26T19:20:50.784517",
      "name": "230811 Schwalmis Oberbauenstock",
      "type": "normal",
      "public": true,
      "userdate": "2023-08-11",
      "meta": {
        "length": 20845.0,
        "totalup": 2166.5,
        "totaldown": 1371.3000000000004,
        "elemin": 774.7,
        "elemax": 2244.8,
        "walking": 542.4559723814034,
        "biking": 245.57421747048338,
        "eBiking": 0.0,
        "winterHiking": 678.1,
        "snowshoeTrekking": 813.7,
        "mountainBiking": 240.5432347318178,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 18367928,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2023-07-25T12:51:04.716462",
      "modifiedAt": "2025-10-26T19:20:42.515074",
      "name": "230725 Frick Foxtrail",
      "type": "normal",
      "public": true,
      "userdate": "2023-07-25",
      "meta": {
        "length": 4930.1,
        "totalup": 92.99999999999994,
        "totaldown": 92.99999999999994,
        "elemin": 341.6,
        "elemax": 410.1,
        "walking": 75.0545932417336,
        "biking": 28.577196875274172,
        "eBiking": 0.0,
        "winterHiking": 93.8,
        "snowshoeTrekking": 112.6,
        "mountainBiking": 26.988534866086493,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1572533992,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2023-06-06T18:47:06.164919",
      "modifiedAt": "2025-10-26T19:20:29.499103",
      "name": "230606 Trechter",
      "type": "normal",
      "public": true,
      "userdate": "2023-06-06",
      "meta": {
        "length": 4036.9,
        "totalup": 42.50000000000006,
        "totaldown": 42.50000000000006,
        "elemin": 503.8,
        "elemax": 521.0,
        "walking": 59.52356071938722,
        "biking": 21.10997670848539,
        "eBiking": 0.0,
        "winterHiking": 74.4,
        "snowshoeTrekking": 89.3,
        "mountainBiking": 19.55867848890022,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 747639111,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2023-05-28T11:46:35.373514",
      "modifiedAt": "2025-10-26T19:20:15.589061",
      "name": "230528 Balsthal Holzweg",
      "type": "normal",
      "public": true,
      "userdate": "2023-05-28",
      "meta": {
        "length": 4917.6,
        "totalup": 291.10000000000014,
        "totaldown": 291.10000000000014,
        "elemin": 510.1,
        "elemax": 661.1,
        "walking": 98.00044761289202,
        "biking": 48.8015087899733,
        "eBiking": 0.0,
        "winterHiking": 122.5,
        "snowshoeTrekking": 147.0,
        "mountainBiking": 46.96432985406656,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 931833390,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2023-01-21T18:48:59.557539",
      "modifiedAt": "2025-10-26T19:20:04.818237",
      "name": "230121 Sursee Willisau",
      "type": "normal",
      "public": true,
      "userdate": "2023-01-21",
      "meta": {
        "length": 12804.3,
        "totalup": 300.7000000000003,
        "totaldown": 267.3000000000003,
        "elemin": 521.3,
        "elemax": 721.4,
        "walking": 200.26595708842163,
        "biking": 82.20470603339773,
        "eBiking": 0.0,
        "winterHiking": 250.3,
        "snowshoeTrekking": 300.4,
        "mountainBiking": 77.50408127960863,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1354850008,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2022-12-09T09:33:55.234011",
      "modifiedAt": "2025-10-26T19:19:55.858102",
      "name": "221208 Notwil Tannenfels",
      "type": "normal",
      "public": true,
      "userdate": "2022-12-08",
      "meta": {
        "length": 13108.5,
        "totalup": 290.40000000000015,
        "totaldown": 290.40000000000015,
        "elemin": 503.0,
        "elemax": 684.2,
        "walking": 202.56771349211758,
        "biking": 86.66072445072052,
        "eBiking": 0.0,
        "winterHiking": 253.2,
        "snowshoeTrekking": 303.9,
        "mountainBiking": 80.84831318346326,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1564524119,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2022-11-06T11:15:55.562678",
      "modifiedAt": "2025-10-26T19:16:39.778044",
      "name": "221106 Wetzwil",
      "type": "normal",
      "public": true,
      "userdate": "2022-11-06",
      "meta": {
        "length": 9005.2,
        "totalup": 374.29999999999984,
        "totaldown": 151.59999999999985,
        "elemin": 499.7,
        "elemax": 796.1,
        "walking": 152.25078744708037,
        "biking": 81.39853291093326,
        "eBiking": 0.0,
        "winterHiking": 190.3,
        "snowshoeTrekking": 228.4,
        "mountainBiking": 76.8859946895046,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 560889153,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2022-10-19T15:34:04.516602",
      "modifiedAt": "2025-10-26T19:16:28.626383",
      "name": "221019 Schlierengrat",
      "type": "normal",
      "public": true,
      "userdate": "2022-10-19",
      "meta": {
        "length": 18340.8,
        "totalup": 868.9000000000008,
        "totaldown": 869.0000000000007,
        "elemin": 1361.8,
        "elemax": 1746.8,
        "walking": 336.5073685026753,
        "biking": 154.37525003959212,
        "eBiking": 0.0,
        "winterHiking": 420.6,
        "snowshoeTrekking": 504.8,
        "mountainBiking": 149.6235864902286,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 2131957483,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2022-07-25T10:00:00.935286",
      "modifiedAt": "2025-10-26T19:16:18.531756",
      "name": "220725 Emmetten Stockhütte",
      "type": "normal",
      "public": true,
      "userdate": "2022-07-25",
      "meta": {
        "length": 4371.6,
        "totalup": 538.2,
        "totaldown": 33.1,
        "elemin": 774.0,
        "elemax": 1279.3,
        "walking": 105.2899982702,
        "biking": 76.0865757767,
        "eBiking": 0.0,
        "winterHiking": 131.6,
        "snowshoeTrekking": 157.9,
        "mountainBiking": 74.98172414450059,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 708334949,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2022-06-17T17:12:07.530424",
      "modifiedAt": "2025-10-26T19:16:08.798017",
      "name": "220617 Zyberliland Romos",
      "type": "normal",
      "public": true,
      "userdate": "2022-06-17",
      "meta": {
        "length": 5524.7,
        "totalup": 288.4,
        "totaldown": 277.7,
        "elemin": 766.5,
        "elemax": 995.9,
        "walking": 103.9,
        "biking": 45.9,
        "eBiking": 0.0,
        "winterHiking": 129.9,
        "snowshoeTrekking": 155.9,
        "mountainBiking": 44.52879340238342,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 423927930,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2022-06-17T17:13:35.090214",
      "modifiedAt": "2025-10-26T19:15:51.299889",
      "name": "220616 Fritzeflue",
      "type": "normal",
      "public": true,
      "userdate": "2022-06-16",
      "meta": {
        "length": 3508.8,
        "totalup": 211.4,
        "totaldown": 211.4,
        "elemin": 928.3,
        "elemax": 1022.6,
        "walking": 72.2,
        "biking": 31.8,
        "eBiking": 0.0,
        "winterHiking": 90.2,
        "snowshoeTrekking": 108.3,
        "mountainBiking": 30.65910212973914,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1341627322,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-12-30T22:54:51.632572",
      "modifiedAt": "2025-10-26T19:15:42.032733",
      "name": "211230 Wohlensee",
      "type": "normal",
      "public": true,
      "userdate": "2021-12-30",
      "meta": {
        "length": 6638.1,
        "totalup": 180.5,
        "totaldown": 180.3,
        "elemin": 481.7,
        "elemax": 609.3,
        "walking": 108.8,
        "biking": 44.9,
        "eBiking": 0.0,
        "winterHiking": 136.0,
        "snowshoeTrekking": 163.2,
        "mountainBiking": 42.859075832865706,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 601055698,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-11-06T17:22:00.916486",
      "modifiedAt": "2025-10-26T19:15:31.296765",
      "name": "211106 Axalp",
      "type": "normal",
      "public": true,
      "userdate": "2021-11-06",
      "meta": {
        "length": 8723.7,
        "totalup": 505.4,
        "totaldown": 505.4,
        "elemin": 1521.0,
        "elemax": 1722.2,
        "walking": 172.5,
        "biking": 68.5,
        "eBiking": 0.0,
        "winterHiking": 215.6,
        "snowshoeTrekking": 258.8,
        "mountainBiking": 66.90791065288754,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1631355292,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-01T08:33:40.023704",
      "modifiedAt": "2025-10-26T19:15:21.197803",
      "name": "211001 Sattelegg Chli Aubrig",
      "type": "normal",
      "public": true,
      "userdate": "2021-10-01",
      "meta": {
        "length": 9527.6,
        "totalup": 592.1,
        "totaldown": 592.1,
        "elemin": 1179.7,
        "elemax": 1641.6,
        "walking": 200.0,
        "biking": 79.1,
        "eBiking": 0.0,
        "winterHiking": 250.0,
        "snowshoeTrekking": 300.0,
        "mountainBiking": 79.61144118223928,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1666239786,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-11-20T21:15:32.980236",
      "modifiedAt": "2025-10-26T19:15:10.585656",
      "name": "210723 Rigi Hohflue",
      "type": "normal",
      "public": true,
      "userdate": "2021-07-23",
      "meta": {
        "length": 5254.1,
        "totalup": 615.2,
        "totaldown": 623.4,
        "elemin": 1137.5,
        "elemax": 1699.1,
        "walking": 176.9,
        "biking": 52.1,
        "eBiking": 0.0,
        "winterHiking": 221.1,
        "snowshoeTrekking": 265.4,
        "mountainBiking": 51.840988912358796,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 7600532,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2020-07-29T11:35:21.120163",
      "modifiedAt": "2025-10-26T19:14:55.424061",
      "name": "200730 Schüpfheim Sursee",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-30",
      "meta": {
        "length": 62216.07475712628,
        "totalup": 1075.5001220703125,
        "totaldown": 1288.400146484375,
        "elemin": 494.5,
        "elemax": 1086.3999938964844,
        "walking": 929.2718238504647,
        "biking": 281.9767302721498,
        "eBiking": 0.0,
        "winterHiking": 1161.8000000000002,
        "snowshoeTrekking": 1393.8999999999999,
        "mountainBiking": 339.2449781928168,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "velo"
      }
    },
    {
      "id": 1099062996,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2022-07-02T19:23:39.947169",
      "modifiedAt": "2025-10-26T19:14:11.411767",
      "name": "210529 Schwarzenbach Mosen",
      "type": "normal",
      "public": true,
      "userdate": "2021-05-29",
      "meta": {
        "length": 8264.8,
        "totalup": 263.9,
        "totaldown": 263.9,
        "elemin": 460.7,
        "elemax": 664.7,
        "walking": 135.029076074,
        "biking": 58.9539305045,
        "eBiking": 0.0,
        "winterHiking": 168.8,
        "snowshoeTrekking": 202.5,
        "mountainBiking": 56.265140570018,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1132188073,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-12-18T15:23:04.726909",
      "modifiedAt": "2025-10-26T19:13:59.729831",
      "name": "201218 Sempachersee",
      "type": "normal",
      "public": true,
      "userdate": "2020-12-18",
      "meta": {
        "length": 22286.0,
        "totalup": 245.7,
        "totaldown": 245.7,
        "elemin": 503.5999999999996,
        "elemax": 581.0000000000001,
        "walking": 326.6,
        "biking": 116.6,
        "eBiking": 0.0,
        "winterHiking": 408.2,
        "snowshoeTrekking": 489.9,
        "mountainBiking": 108.42084938731404,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1521347853,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-12-26T20:44:45.845396",
      "modifiedAt": "2025-10-26T19:13:44.738416",
      "name": "201226 Balmberg Weissenstein",
      "type": "normal",
      "public": true,
      "userdate": "2020-12-26",
      "meta": {
        "length": 9133.8,
        "totalup": 446.1,
        "totaldown": 446.1,
        "elemin": 1056.21,
        "elemax": 1395.2800000000004,
        "walking": 170.9,
        "biking": 86.4,
        "eBiking": 0.0,
        "winterHiking": 213.6,
        "snowshoeTrekking": 256.4,
        "mountainBiking": 83.18231659781264,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1925485379,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-06-26T15:43:35.891136",
      "modifiedAt": "2025-10-26T19:13:36.094720",
      "name": "210626 Schratteflue",
      "type": "normal",
      "public": true,
      "userdate": "2021-06-26",
      "meta": {
        "length": 12472.4,
        "totalup": 940.9,
        "totaldown": 940.9,
        "elemin": 1276.57,
        "elemax": 2064.3900000000017,
        "walking": 289.4,
        "biking": 121.4,
        "eBiking": 0.0,
        "winterHiking": 361.8,
        "snowshoeTrekking": 434.1,
        "mountainBiking": 117.7141347108352,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 26170594,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-09-22T16:55:59.119820",
      "modifiedAt": "2025-10-26T19:13:28.139300",
      "name": "210923 Hohgant",
      "type": "normal",
      "public": true,
      "userdate": "2021-09-23",
      "meta": {
        "length": 19390.5,
        "totalup": 1364.3,
        "totaldown": 1364.1,
        "elemin": 976.0,
        "elemax": 2162.4,
        "walking": 431.4,
        "biking": 164.3,
        "eBiking": 0.0,
        "winterHiking": 539.2,
        "snowshoeTrekking": 647.1,
        "mountainBiking": 166.49081803102482,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 2119274758,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-11-29T17:03:36.570960",
      "modifiedAt": "2025-10-26T19:13:19.710319",
      "name": "201129 Beichle",
      "type": "normal",
      "public": true,
      "userdate": "2020-11-29",
      "meta": {
        "length": 6496.4,
        "totalup": 667.3,
        "totaldown": 667.3,
        "elemin": 1176.4599999999998,
        "elemax": 1701.9800000000002,
        "walking": 193.2,
        "biking": 71.4,
        "eBiking": 0.0,
        "winterHiking": 241.5,
        "snowshoeTrekking": 289.8,
        "mountainBiking": 70.48328582379722,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 413594081,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-11-17T19:23:25.924727",
      "modifiedAt": "2025-10-26T19:12:51.638481",
      "name": "201118 Fürstein",
      "type": "normal",
      "public": true,
      "userdate": "2020-11-18",
      "meta": {
        "length": 7864.9,
        "totalup": 686.4,
        "totaldown": 685.7,
        "elemin": 1540.0,
        "elemax": 2039.0,
        "walking": 206.1,
        "biking": 69.8,
        "eBiking": 0.0,
        "winterHiking": 257.6,
        "snowshoeTrekking": 309.1,
        "mountainBiking": 69.37331742368248,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 2108188329,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-10-18T21:55:03.236788",
      "modifiedAt": "2025-10-26T19:12:40.428216",
      "name": "201018 Staffelegg Brugg",
      "type": "normal",
      "public": true,
      "userdate": "2020-10-18",
      "meta": {
        "length": 17151.2,
        "totalup": 343.8,
        "totaldown": 611.3,
        "elemin": 340.65,
        "elemax": 751.7100000000002,
        "walking": 263.1,
        "biking": 101.4,
        "eBiking": 0.0,
        "winterHiking": 328.9,
        "snowshoeTrekking": 394.7,
        "mountainBiking": 95.4926713869009,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 123174054,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-09-16T08:15:38.685484",
      "modifiedAt": "2025-10-26T19:12:30.225540",
      "name": "200916 Axalp Faulhorn",
      "type": "normal",
      "public": true,
      "userdate": "2020-09-16",
      "meta": {
        "length": 22221.2,
        "totalup": 1877.3,
        "totaldown": 1878.6,
        "elemin": 1088.2699999999982,
        "elemax": 2666.8,
        "walking": 568.3,
        "biking": 223.3,
        "eBiking": 0.0,
        "winterHiking": 710.4,
        "snowshoeTrekking": 852.4,
        "mountainBiking": 219.7898801554242,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 7867115,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-26T19:12:18.616266",
      "name": "200826 Ebenalp Meglisalp Wasserauen",
      "type": "normal",
      "public": true,
      "userdate": "2020-08-26",
      "meta": {
        "length": 16011.5,
        "totalup": 1083.5,
        "totaldown": 1813.1,
        "elemin": 863.4100000000014,
        "elemax": 1918.8699999999997,
        "walking": 406.3,
        "biking": 139.9,
        "eBiking": 0.0,
        "winterHiking": 507.9,
        "snowshoeTrekking": 609.5,
        "mountainBiking": 134.2956562240393,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 190998111,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-05-26T16:40:27.731686",
      "modifiedAt": "2025-10-26T19:11:27.118696",
      "name": "230526 St. Urban",
      "type": "normal",
      "public": true,
      "userdate": "2023-05-26",
      "meta": {
        "length": 65092.73741823435,
        "totalup": 1259.68212890625,
        "totaldown": 1259.5821228027344,
        "elemin": 456.6,
        "elemax": 731.9,
        "walking": 996.5238378010297,
        "biking": 426.1474457470878,
        "eBiking": 0.0,
        "winterHiking": 1245.7,
        "snowshoeTrekking": 1494.8,
        "mountainBiking": 400.3702345056717,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7330063,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-07-05T21:20:54.082622",
      "modifiedAt": "2025-10-26T19:11:11.919602",
      "name": "200821 Gotthard Rundwanderung",
      "type": "normal",
      "public": true,
      "userdate": "2020-08-21",
      "meta": {
        "length": 10898.9,
        "totalup": 670.7,
        "totaldown": 671.3,
        "elemin": 2046.4299999999998,
        "elemax": 2530.3300000000067,
        "walking": 234.6,
        "biking": 96.8,
        "eBiking": 0.0,
        "winterHiking": 293.2,
        "snowshoeTrekking": 351.9,
        "mountainBiking": 89.7530115196201,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 7589279,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2020-07-28T12:12:53.257065",
      "modifiedAt": "2025-10-26T19:10:59.170005",
      "name": "200728 Sursee Langnau",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-28",
      "meta": {
        "length": 60663.83501656347,
        "totalup": 1153.9003295898438,
        "totaldown": 988.600341796875,
        "elemin": 497.8999938964844,
        "elemax": 937.0999755859375,
        "walking": 919.1920860360302,
        "biking": 293.6022145351942,
        "eBiking": 0.0,
        "winterHiking": 1149.2999999999997,
        "snowshoeTrekking": 1378.6000000000001,
        "mountainBiking": 361.58165580995353,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "velo"
      }
    },
    {
      "id": 7330026,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-07-05T21:15:33.310960",
      "modifiedAt": "2025-10-26T19:08:21.807367",
      "name": "200707 Realp Rotondo",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-07",
      "meta": {
        "length": 25337.3,
        "totalup": 1612.1,
        "totaldown": 1611.9,
        "elemin": 1537.5,
        "elemax": 2650.0,
        "walking": 545.7,
        "biking": 240.2,
        "eBiking": 0.0,
        "winterHiking": 682.1,
        "snowshoeTrekking": 818.6,
        "mountainBiking": 223.47418252468663,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 7358881,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-07-08T18:26:31.245884",
      "modifiedAt": "2025-10-26T19:08:08.337263",
      "name": "200708 Garschigsee Rotondo Realp",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-08",
      "meta": {
        "length": 18760.9,
        "totalup": 695.7,
        "totaldown": 1604.1,
        "elemin": 1538.2,
        "elemax": 2650.0,
        "walking": 364.7,
        "biking": 127.3,
        "eBiking": 0.0,
        "winterHiking": 455.9,
        "snowshoeTrekking": 547.0,
        "mountainBiking": 118.33673867620821,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 7358849,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-07-08T18:23:10.545889",
      "modifiedAt": "2025-10-26T19:08:01.184953",
      "name": "200707 Realp Garschigsee",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-08",
      "meta": {
        "length": 8492.0,
        "totalup": 1014.0,
        "totaldown": 104.8,
        "elemin": 1537.4,
        "elemax": 2526.4,
        "walking": 216.5,
        "biking": 130.9,
        "eBiking": 0.0,
        "winterHiking": 270.6,
        "snowshoeTrekking": 324.8,
        "mountainBiking": 118.94545484099113,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 7117155,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-06-13T09:19:56.681550",
      "modifiedAt": "2025-10-26T19:07:01.516478",
      "name": "200612 Gastlosen",
      "type": "normal",
      "public": true,
      "userdate": "2020-06-12",
      "meta": {
        "length": 11050.6,
        "totalup": 791.3,
        "totaldown": 791.3,
        "elemin": 1459.0499999999993,
        "elemax": 1927.9099999999992,
        "walking": 251.4,
        "biking": 116.3,
        "eBiking": 0.0,
        "winterHiking": 314.2,
        "snowshoeTrekking": 377.1,
        "mountainBiking": 107.97695140092746,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6694445,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-04-25T09:08:01.736113",
      "modifiedAt": "2025-10-26T19:06:50.843954",
      "name": "200424 Gschweich",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-24",
      "meta": {
        "length": 12551.4,
        "totalup": 362.5,
        "totaldown": 362.5,
        "elemin": 615.9,
        "elemax": 834.1,
        "walking": 199.3,
        "biking": 107.8,
        "eBiking": 0.0,
        "winterHiking": 249.1,
        "snowshoeTrekking": 299.0,
        "mountainBiking": 91.49264253333806,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1313315947,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-07T11:23:16.625226",
      "modifiedAt": "2025-10-26T19:06:29.807584",
      "name": "200726 Schwarzsee Zermatt",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-26",
      "meta": {
        "length": 9942.659987926483,
        "totalup": 111.7999267578125,
        "totaldown": 1078.800048828125,
        "elemin": 1619.6,
        "elemax": 2586.6,
        "walking": 179.9257372147537,
        "biking": 41.57263222999008,
        "eBiking": 0.0,
        "winterHiking": 224.9,
        "snowshoeTrekking": 269.9,
        "mountainBiking": 34.738990885535245,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1886814114,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-07T11:30:35.180025",
      "modifiedAt": "2025-10-26T19:06:19.350897",
      "name": "200726 Blauherd Zermatt",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-26",
      "meta": {
        "length": 9251.977750360966,
        "totalup": 10.699951171875,
        "totaldown": 985.4998779296875,
        "elemin": 1603.9,
        "elemax": 2579.1,
        "walking": 157.703554504832,
        "biking": 27.050724076058614,
        "eBiking": 0.0,
        "winterHiking": 197.1,
        "snowshoeTrekking": 236.6,
        "mountainBiking": 15.188343747408782,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1243383005,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-07T11:26:26.595740",
      "modifiedAt": "2025-10-26T19:06:07.857103",
      "name": "200723 Gornergrat Zermatt",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-23",
      "meta": {
        "length": 10499.134462088346,
        "totalup": 5.5,
        "totaldown": 1465.2999267578125,
        "elemin": 1630.6,
        "elemax": 3090.4,
        "walking": 186.99192080962905,
        "biking": 21.419524285070906,
        "eBiking": 0.0,
        "winterHiking": 233.7,
        "snowshoeTrekking": 280.5,
        "mountainBiking": 15.26500115310833,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6773803,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-05-08T13:36:45.573884",
      "modifiedAt": "2025-10-26T19:05:41.206753",
      "name": "200508 Amsteg Golzerensee",
      "type": "normal",
      "public": true,
      "userdate": "2020-05-08",
      "meta": {
        "length": 24011.681523025036,
        "totalup": 1211.499755859375,
        "totaldown": 1211.2998046875,
        "elemin": 510.8,
        "elemax": 1510.2,
        "walking": 482.8,
        "biking": 244.7,
        "eBiking": 0.0,
        "winterHiking": 603.5,
        "snowshoeTrekking": 724.2,
        "mountainBiking": 218.15913943819402,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6974850,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-05-29T15:38:04.669127",
      "modifiedAt": "2025-10-26T19:05:29.599301",
      "name": "200529 Eigental Mittaggüpfi",
      "type": "normal",
      "public": true,
      "userdate": "2020-05-29",
      "meta": {
        "length": 16151.1,
        "totalup": 1109.9,
        "totaldown": 1109.9,
        "elemin": 970.1399999999996,
        "elemax": 1910.2600000000014,
        "walking": 379.0,
        "biking": 159.6,
        "eBiking": 0.0,
        "winterHiking": 473.8,
        "snowshoeTrekking": 568.5,
        "mountainBiking": 145.23543242420772,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6744690,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-05-03T15:29:48.608188",
      "modifiedAt": "2025-10-26T19:05:21.297089",
      "name": "200503 Soppisee Ostergau",
      "type": "normal",
      "public": true,
      "userdate": "2020-05-03",
      "meta": {
        "length": 14964.3,
        "totalup": 314.6,
        "totaldown": 315.1,
        "elemin": 552.6,
        "elemax": 670.0,
        "walking": 229.6,
        "biking": 107.5,
        "eBiking": 0.0,
        "winterHiking": 287.0,
        "snowshoeTrekking": 344.4,
        "mountainBiking": 89.02878931687094,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6720353,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-04-29T15:35:46.162188",
      "modifiedAt": "2025-10-26T19:05:13.005741",
      "name": "200429 Eich Sempach",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-29",
      "meta": {
        "length": 12103.7,
        "totalup": 348.8,
        "totaldown": 349.1,
        "elemin": 513.9,
        "elemax": 751.2,
        "walking": 196.7,
        "biking": 90.2,
        "eBiking": 0.0,
        "winterHiking": 245.9,
        "snowshoeTrekking": 295.0,
        "mountainBiking": 80.1110466188896,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6707495,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-04-26T16:13:20.225199",
      "modifiedAt": "2025-10-26T19:03:43.420304",
      "name": "200427 Ahorn Napf",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-27",
      "meta": {
        "length": 21831.2,
        "totalup": 1142.5,
        "totaldown": 1143.3,
        "elemin": 1109.6799999999996,
        "elemax": 1405.0800000000002,
        "walking": 430.3,
        "biking": 200.0,
        "eBiking": 0.0,
        "winterHiking": 537.9,
        "snowshoeTrekking": 645.5,
        "mountainBiking": 180.13493787248686,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6694401,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-04-25T09:04:45.173839",
      "modifiedAt": "2025-10-26T19:03:32.592847",
      "name": "200417 Büron Krumbach",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-17",
      "meta": {
        "length": 8990.8,
        "totalup": 325.5,
        "totaldown": 325.5,
        "elemin": 510.48999999999995,
        "elemax": 728.1100000000001,
        "walking": 149.7,
        "biking": 86.3,
        "eBiking": 0.0,
        "winterHiking": 187.1,
        "snowshoeTrekking": 224.5,
        "mountainBiking": 73.79739117637703,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6630442,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-04-16T14:06:02.568857",
      "modifiedAt": "2025-10-26T19:03:02.067318",
      "name": "200416 Walbert Tobel",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-16",
      "meta": {
        "length": 10985.5,
        "totalup": 321.1,
        "totaldown": 321.2,
        "elemin": 489.2,
        "elemax": 742.5,
        "walking": 178.2,
        "biking": 89.6,
        "eBiking": 0.0,
        "winterHiking": 222.8,
        "snowshoeTrekking": 267.3,
        "mountainBiking": 73.84760122966527,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 5805718,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2019-07-27T11:22:25.233326",
      "modifiedAt": "2025-10-26T19:02:48.305194",
      "name": "190727 Buochserhorn Musenalp",
      "type": "normal",
      "public": true,
      "userdate": "2019-07-27",
      "meta": {
        "length": 10136.8,
        "totalup": 1222.0,
        "totaldown": 632.5,
        "elemin": 915.1100000000001,
        "elemax": 1806.3899999999999,
        "walking": 296.0,
        "biking": 116.8,
        "eBiking": 0.0,
        "winterHiking": 370.0,
        "snowshoeTrekking": 444.0,
        "mountainBiking": 113.14160198488678,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6767836,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-05-07T16:05:55.967802",
      "modifiedAt": "2025-10-26T19:02:32.980432",
      "name": "200507 Rigi",
      "type": "normal",
      "public": true,
      "userdate": "2020-05-07",
      "meta": {
        "length": 27682.2444627285,
        "totalup": 1416.7998962402344,
        "totaldown": 1416.6998901367188,
        "elemin": 437.7,
        "elemax": 1797.0,
        "walking": 526.6,
        "biking": 287.9,
        "eBiking": 0.0,
        "winterHiking": 658.2,
        "snowshoeTrekking": 789.9,
        "mountainBiking": 265.1162848627936,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1476639416,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-10-30T18:59:46.571887",
      "modifiedAt": "2025-10-26T19:01:47.418793",
      "name": "221030 Vogelmoos",
      "type": "normal",
      "public": true,
      "userdate": "2022-10-30",
      "meta": {
        "length": 37652.15327394043,
        "totalup": 818.8998718261719,
        "totaldown": 819.2998962402344,
        "elemin": 501.5999755859375,
        "elemax": 854.3999938964844,
        "walking": 575.5395630663878,
        "biking": 251.7455800600831,
        "eBiking": 0.0,
        "winterHiking": 719.2000000000002,
        "snowshoeTrekking": 863.2000000000002,
        "mountainBiking": 235.1748738314594,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6626656,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2020-04-15T19:45:15.836735",
      "modifiedAt": "2025-10-26T19:01:18.692656",
      "name": "200415 Lätte",
      "type": "normal",
      "public": true,
      "userdate": "2020-04-15",
      "meta": {
        "length": 15594.2,
        "totalup": 458.0,
        "totaldown": 458.0,
        "elemin": 470.5700000000001,
        "elemax": 733.22,
        "walking": 251.6,
        "biking": 126.6,
        "eBiking": 0.0,
        "winterHiking": 314.5,
        "snowshoeTrekking": 377.4,
        "mountainBiking": 108.96894651437923,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 6137461,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2019-09-29T16:52:33.867006",
      "modifiedAt": "2025-10-26T19:01:07.904950",
      "name": "190929 Uri Rotstock",
      "type": "normal",
      "public": true,
      "userdate": "2019-09-29",
      "meta": {
        "length": 13681.6,
        "totalup": 1572.9,
        "totaldown": 1572.8,
        "elemin": 1484.12,
        "elemax": 2925.99,
        "walking": 441.9,
        "biking": 143.8,
        "eBiking": 0.0,
        "winterHiking": 552.4,
        "snowshoeTrekking": 662.8,
        "mountainBiking": 141.32704121671472,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 5937082,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2019-08-17T12:46:11.308976",
      "modifiedAt": "2025-10-26T19:00:59.458188",
      "name": "190817 Sörenberg Höch Gumme Rothorn",
      "type": "normal",
      "public": true,
      "userdate": "2019-08-17",
      "meta": {
        "length": 17150.2,
        "totalup": 1557.2,
        "totaldown": 1557.4,
        "elemin": 1229.04,
        "elemax": 2343.410000000001,
        "walking": 456.2,
        "biking": 194.6,
        "eBiking": 0.0,
        "winterHiking": 570.2,
        "snowshoeTrekking": 684.3,
        "mountainBiking": 188.8772930495611,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 5862976,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2019-08-04T14:21:41.562202",
      "modifiedAt": "2025-10-26T19:00:48.413739",
      "name": "190804 Grafenort Engelberg",
      "type": "normal",
      "public": true,
      "userdate": "2019-08-04",
      "meta": {
        "length": 13813.4,
        "totalup": 616.6,
        "totaldown": 114.6,
        "elemin": 567.0899999999999,
        "elemax": 1099.1899999999998,
        "walking": 237.8,
        "biking": 149.2,
        "eBiking": 0.0,
        "winterHiking": 297.2,
        "snowshoeTrekking": 356.7,
        "mountainBiking": 124.38888673389242,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 4999219,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2018-10-05T13:48:52.708074",
      "modifiedAt": "2025-10-26T19:00:36.894460",
      "name": "181005 Schrattenflueh",
      "type": "normal",
      "public": true,
      "userdate": "2018-10-05",
      "meta": {
        "length": 18289.6,
        "totalup": 1277.5,
        "totaldown": 1276.9,
        "elemin": 1068.5,
        "elemax": 2077.0,
        "walking": 411.4367827078,
        "biking": 171.7297129209,
        "eBiking": 0.0,
        "winterHiking": 514.3,
        "snowshoeTrekking": 617.2,
        "mountainBiking": 174.1590916344916,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 4928170,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2018-09-16T14:16:02.603419",
      "modifiedAt": "2025-10-26T19:00:27.348458",
      "name": "180916 Brisen",
      "type": "normal",
      "public": true,
      "userdate": "2018-09-16",
      "meta": {
        "length": 13364.5,
        "totalup": 1292.6,
        "totaldown": 1313.0,
        "elemin": 1154.6700000000017,
        "elemax": 2402.6800000000003,
        "walking": 371.0096058519,
        "biking": 131.1657593109,
        "eBiking": 0.0,
        "winterHiking": 463.8,
        "snowshoeTrekking": 556.5,
        "mountainBiking": 127.69531453827685,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 4922199,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2018-09-15T11:26:57.425923",
      "modifiedAt": "2025-10-26T18:59:50.211512",
      "name": "180912 Rophaien",
      "type": "normal",
      "public": true,
      "userdate": "2018-09-12",
      "meta": {
        "length": 9823.7,
        "totalup": 696.1,
        "totaldown": 1250.8,
        "elemin": 1162.9199999999998,
        "elemax": 2076.1400000000003,
        "walking": 266.1317737703,
        "biking": 79.1545638834,
        "eBiking": 0.0,
        "winterHiking": 332.7,
        "snowshoeTrekking": 399.2,
        "mountainBiking": 78.32255536908187,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 4659866,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2018-07-22T18:49:25.600377",
      "modifiedAt": "2025-10-26T18:59:39.593431",
      "name": "180723 Göscheneralpsee",
      "type": "normal",
      "public": true,
      "userdate": "2018-07-23",
      "meta": {
        "length": 12319.2,
        "totalup": 1022.7,
        "totaldown": 1008.3,
        "elemin": 1771.18,
        "elemax": 2436.950000000001,
        "walking": 311.0901998234,
        "biking": 125.4805666444,
        "eBiking": 0.0,
        "winterHiking": 388.9,
        "snowshoeTrekking": 466.6,
        "mountainBiking": 120.548916692645,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 4017003,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2017-10-18T15:26:30.544691",
      "modifiedAt": "2025-10-26T18:59:29.100946",
      "name": "171018 Gfellen Pilatus Alpnach",
      "type": "normal",
      "public": true,
      "userdate": "2017-10-18",
      "meta": {
        "length": 21496.2,
        "totalup": 1777.2,
        "totaldown": 2358.3,
        "elemin": 434.94000000000005,
        "elemax": 2125.63,
        "walking": 567.629166390387,
        "biking": 203.34675886574902,
        "eBiking": 0.0,
        "winterHiking": 709.5,
        "snowshoeTrekking": 851.4,
        "mountainBiking": 195.1526536774836,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 3988258,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2017-10-11T16:50:44.074067",
      "modifiedAt": "2025-10-26T18:59:16.842388",
      "name": "171010 Haglere",
      "type": "normal",
      "public": true,
      "userdate": "2017-10-10",
      "meta": {
        "length": 13163.3,
        "totalup": 1069.2,
        "totaldown": 1069.4,
        "elemin": 1254.6799999999996,
        "elemax": 1948.3000000000013,
        "walking": 323.94982240192485,
        "biking": 126.96447717671838,
        "eBiking": 0.0,
        "winterHiking": 404.9,
        "snowshoeTrekking": 485.9,
        "mountainBiking": 137.50001234936028,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 5630535,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2019-06-23T15:23:08.969146",
      "modifiedAt": "2025-10-26T18:58:52.753188",
      "name": "190623 Eigental Trochematt",
      "type": "normal",
      "public": true,
      "userdate": "2019-06-23",
      "meta": {
        "length": 38264.66961823404,
        "totalup": 1314.0659484863281,
        "totaldown": 1314.1659545898438,
        "elemin": 435.2,
        "elemax": 1455.3,
        "walking": 637.6,
        "biking": 356.0,
        "eBiking": 0.0,
        "winterHiking": 797.0,
        "snowshoeTrekking": 956.4,
        "mountainBiking": 314.99831044475195,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 5539613,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2019-06-02T14:55:11.071002",
      "modifiedAt": "2025-10-26T18:57:11.886802",
      "name": "190602 Renggpass Lütholdsmatt",
      "type": "normal",
      "public": true,
      "userdate": "2019-06-02",
      "meta": {
        "length": 48796.666922047734,
        "totalup": 1306.240234375,
        "totaldown": 1307.1402282714844,
        "elemin": 434.0,
        "elemax": 1149.1,
        "walking": 805.4,
        "biking": 398.2,
        "eBiking": 0.0,
        "winterHiking": 1006.8,
        "snowshoeTrekking": 1208.1,
        "mountainBiking": 349.5576005310757,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 3981311,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2017-10-09T19:01:54.417630",
      "modifiedAt": "2025-10-26T18:53:22.661834",
      "name": "171009 Oberalppass Tomasee",
      "type": "normal",
      "public": true,
      "userdate": "2017-10-09",
      "meta": {
        "length": 10183.3,
        "totalup": 869.7,
        "totaldown": 869.8,
        "elemin": 1980.07,
        "elemax": 2740.2699999999995,
        "walking": 257.48268289161416,
        "biking": 91.17922560446733,
        "eBiking": 0.0,
        "winterHiking": 321.9,
        "snowshoeTrekking": 386.2,
        "mountainBiking": 95.88099478276551,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 3981297,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2017-10-09T18:59:21.805768",
      "modifiedAt": "2025-10-26T18:53:05.629077",
      "name": "171008 Entlebuch Albliegg",
      "type": "normal",
      "public": true,
      "userdate": "2017-10-08",
      "meta": {
        "length": 14050.4,
        "totalup": 636.5,
        "totaldown": 636.8,
        "elemin": 682.3,
        "elemax": 1281.9,
        "walking": 251.88873113573305,
        "biking": 94.81213513320793,
        "eBiking": 0.0,
        "winterHiking": 314.9,
        "snowshoeTrekking": 377.8,
        "mountainBiking": 110.16255955259577,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 3812317,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2017-08-15T12:47:18.143201",
      "modifiedAt": "2025-10-24T20:48:27.636739",
      "name": "170815 Goldau Sattel",
      "type": "normal",
      "public": true,
      "userdate": "2017-08-15",
      "meta": {
        "length": 11743.8,
        "totalup": 1165.4,
        "totaldown": 903.6,
        "elemin": 504.3,
        "elemax": 1572.0,
        "walking": 320.45267389214405,
        "biking": 101.57265259006213,
        "eBiking": 0.0,
        "winterHiking": 400.6,
        "snowshoeTrekking": 480.7,
        "mountainBiking": 112.69142774020997,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2659146,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:44:48.046721",
      "name": "160507 Grächen Hannigalp",
      "type": "normal",
      "public": true,
      "userdate": "2016-05-07",
      "meta": {
        "length": 5356.6,
        "totalup": 412.7,
        "totaldown": 412.4,
        "elemin": 1729.35,
        "elemax": 2121.64,
        "walking": 125.042882702,
        "biking": 46.1001297277,
        "eBiking": 0.0,
        "winterHiking": 156.3,
        "snowshoeTrekking": 187.6,
        "mountainBiking": 45.51699895235167,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2427175,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:43:46.294077",
      "name": "151024 Saignelegier Tramelan",
      "type": "normal",
      "public": true,
      "userdate": "2015-10-24",
      "meta": {
        "length": 13711.9,
        "totalup": 261.09999999999957,
        "totaldown": 355.59999999999957,
        "elemin": 887.4,
        "elemax": 1054.5,
        "walking": 209.390867308114,
        "biking": 64.28577226269911,
        "eBiking": 0.0,
        "winterHiking": 261.7,
        "snowshoeTrekking": 314.1,
        "mountainBiking": 78.57860183683589,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2953801,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:43:20.935331",
      "name": "160816 Hochänzi",
      "type": "normal",
      "public": true,
      "userdate": "2016-08-16",
      "meta": {
        "length": 9245.4,
        "totalup": 539.8,
        "totaldown": 540.2,
        "elemin": 873.07,
        "elemax": 1332.0,
        "walking": 186.567725525,
        "biking": 89.7297366624,
        "eBiking": 0.0,
        "winterHiking": 233.2,
        "snowshoeTrekking": 279.9,
        "mountainBiking": 82.40539615947311,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2659132,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:43:04.062621",
      "name": "160506 Grächen Gletscher",
      "type": "normal",
      "public": true,
      "userdate": "2016-05-06",
      "meta": {
        "length": 10752.4,
        "totalup": 351.4,
        "totaldown": 351.7,
        "elemin": 1724.15,
        "elemax": 2034.43,
        "walking": 190.181249271,
        "biking": 71.7495750322,
        "eBiking": 0.0,
        "winterHiking": 237.7,
        "snowshoeTrekking": 285.3,
        "mountainBiking": 64.8511855202833,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2427183,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:42:20.451343",
      "name": "151101 Niederrickenbach Musenalp",
      "type": "normal",
      "public": true,
      "userdate": "2015-11-01",
      "meta": {
        "length": 3296.0,
        "totalup": 610.2,
        "totaldown": 18.6,
        "elemin": 1154.67,
        "elemax": 1756.87,
        "walking": 111.643607706,
        "biking": 57.2813362451,
        "eBiking": 0.0,
        "winterHiking": 139.6,
        "snowshoeTrekking": 167.5,
        "mountainBiking": 55.578575828812895,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2953849,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:42:12.671147",
      "name": "150731 Maderanertal",
      "type": "normal",
      "public": true,
      "userdate": "2015-07-31",
      "meta": {
        "length": 15951.6,
        "totalup": 1307.8,
        "totaldown": 731.1,
        "elemin": 821.77,
        "elemax": 2031.61,
        "walking": 358.246457352,
        "biking": 205.927870026,
        "eBiking": 0.0,
        "winterHiking": 447.8,
        "snowshoeTrekking": 537.4,
        "mountainBiking": 190.92446653784125,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2085723,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:41:39.952525",
      "name": "150525 Pilatus",
      "type": "normal",
      "public": true,
      "userdate": "2015-05-25",
      "meta": {
        "length": 11837.0,
        "totalup": 972.1,
        "totaldown": 1367.3,
        "elemin": 1009.4,
        "elemax": 2084.3,
        "walking": 333.6,
        "biking": 101.1,
        "eBiking": 0.0,
        "winterHiking": 417.0,
        "snowshoeTrekking": 500.4,
        "mountainBiking": 113.33409344926872,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2184445,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:41:31.261297",
      "name": "150712 Eggberge Klausenpass",
      "type": "normal",
      "public": true,
      "userdate": "2015-07-12",
      "meta": {
        "length": 19842.5,
        "totalup": 1029.8,
        "totaldown": 639.4,
        "elemin": 1447.85,
        "elemax": 1870.22,
        "walking": 359.314444846,
        "biking": 195.056266229,
        "eBiking": 0.0,
        "winterHiking": 449.1,
        "snowshoeTrekking": 539.0,
        "mountainBiking": 180.32366297746998,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2085714,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:41:14.281163",
      "name": "150525 Pilatus, Teil 2",
      "type": "normal",
      "public": true,
      "userdate": "2015-05-25",
      "meta": {
        "length": 7625.2,
        "totalup": 190.1,
        "totaldown": 585.2,
        "elemin": 1010.0,
        "elemax": 1417.3,
        "walking": 128.8,
        "biking": 33.6,
        "eBiking": 0.0,
        "winterHiking": 161.0,
        "snowshoeTrekking": 193.2,
        "mountainBiking": 38.58785444580437,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2085706,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:41:07.875826",
      "name": "150525 Pilatus, Teil 1",
      "type": "normal",
      "public": true,
      "userdate": "2015-05-25",
      "meta": {
        "length": 3280.3,
        "totalup": 771.6,
        "totaldown": 124.3,
        "elemin": 1345.5,
        "elemax": 2092.8,
        "walking": 142.4,
        "biking": 51.5,
        "eBiking": 0.0,
        "winterHiking": 178.0,
        "snowshoeTrekking": 213.6,
        "mountainBiking": 53.00855555858553,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1877110,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:40:35.663998",
      "name": "141002 Niesen",
      "type": "normal",
      "public": true,
      "userdate": "2014-10-02",
      "meta": {
        "length": 9136.7,
        "totalup": 1741.4,
        "totaldown": 10.6,
        "elemin": 628.2,
        "elemax": 2359.1,
        "walking": 303.7,
        "biking": 159.3,
        "eBiking": 0.0,
        "winterHiking": 379.6,
        "snowshoeTrekking": 455.5,
        "mountainBiking": 162.67570740441568,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 240286201,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:40:32.927003",
      "modifiedAt": "2025-10-24T20:18:24.705841",
      "name": "0????? Chur Altstätten",
      "type": "normal",
      "public": true,
      "userdate": "2011-07-24",
      "meta": {
        "length": 87694.22653492607,
        "totalup": 503.2000427246094,
        "totaldown": 637.300048828125,
        "elemin": 419.8999938964844,
        "elemax": 629.6999816894531,
        "walking": 1259.2353339317783,
        "biking": 296.3111466912854,
        "eBiking": 0.0,
        "winterHiking": 1574.1000000000001,
        "snowshoeTrekking": 1888.8000000000002,
        "mountainBiking": 356.96777380887653,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 1832784,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:17:11.968344",
      "name": "140904 Kottwil Arig Nottwil",
      "type": "normal",
      "public": true,
      "userdate": "2014-09-04",
      "meta": {
        "length": 28809.658492643575,
        "totalup": 459.4000549316406,
        "totaldown": 451.00006103515625,
        "elemin": 495.29998779296875,
        "elemax": 737.5,
        "walking": 426.4503480561828,
        "biking": 126.94666964314492,
        "eBiking": 0.0,
        "winterHiking": 533.5000000000001,
        "snowshoeTrekking": 640.3000000000003,
        "mountainBiking": 159.79244608559316,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "velo"
      }
    },
    {
      "id": 1832768,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:17:04.131202",
      "name": "140806 Finsterwald Schimbrig",
      "type": "normal",
      "public": true,
      "userdate": "2014-08-06",
      "meta": {
        "length": 18905.3,
        "totalup": 1051.4,
        "totaldown": 1053.4,
        "elemin": 992.1,
        "elemax": 1810.5,
        "walking": 401.7,
        "biking": 122.8,
        "eBiking": 0.0,
        "winterHiking": 502.1,
        "snowshoeTrekking": 602.5,
        "mountainBiking": 148.43748257404417,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1877120,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:16:57.152100",
      "name": "130818 Vitznauerstock",
      "type": "normal",
      "public": true,
      "userdate": "2013-08-18",
      "meta": {
        "length": 7042.6,
        "totalup": 406.8,
        "totaldown": 1031.1,
        "elemin": 439.6,
        "elemax": 1438.1,
        "walking": 184.8,
        "biking": 47.4,
        "eBiking": 0.0,
        "winterHiking": 231.0,
        "snowshoeTrekking": 277.2,
        "mountainBiking": 53.658616593727906,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1832773,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:16:34.182576",
      "name": "130807 Schluchberg",
      "type": "normal",
      "public": true,
      "userdate": "2013-08-07",
      "meta": {
        "length": 14562.2,
        "totalup": 1739.2,
        "totaldown": 901.4,
        "elemin": 571.4,
        "elemax": 2090.8,
        "walking": 438.0,
        "biking": 147.9,
        "eBiking": 0.0,
        "winterHiking": 547.5,
        "snowshoeTrekking": 657.0,
        "mountainBiking": 167.2415323478881,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1832780,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:16:26.088010",
      "name": "130802 Muttseehütte",
      "type": "normal",
      "public": true,
      "userdate": "2013-08-02",
      "meta": {
        "length": 7719.9,
        "totalup": 634.1,
        "totaldown": 835.8,
        "elemin": 1863.4,
        "elemax": 2573.3,
        "walking": 202.9,
        "biking": 75.6,
        "eBiking": 0.0,
        "winterHiking": 253.6,
        "snowshoeTrekking": 304.4,
        "mountainBiking": 79.038942074899,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 2953824,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-24T20:14:50.093215",
      "name": "130722 Brünig Rothorn",
      "type": "normal",
      "public": true,
      "userdate": "2013-07-22",
      "meta": {
        "length": 11495.2,
        "totalup": 1502.3,
        "totaldown": 234.0,
        "elemin": 1001.36,
        "elemax": 2293.38,
        "walking": 306.8,
        "biking": 174.1,
        "eBiking": 0.0,
        "winterHiking": 383.5,
        "snowshoeTrekking": 460.2,
        "mountainBiking": 166.81265684553313,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 686037120,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-17T19:07:48.646129",
      "modifiedAt": "2025-10-24T20:03:38.226893",
      "name": "041004 Triengen Gurtnellen",
      "type": "normal",
      "public": true,
      "userdate": "2004-10-04",
      "meta": {
        "length": 109367.29267222926,
        "totalup": 1347.2998657226562,
        "totaldown": 1124.6998596191406,
        "elemin": 431.5999755859375,
        "elemax": 737.3999938964844,
        "walking": 1602.9438376925332,
        "biking": 445.54794717682444,
        "eBiking": 0.0,
        "winterHiking": 2003.6999999999996,
        "snowshoeTrekking": 2404.4,
        "mountainBiking": 555.6739975681545,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 561520864,
      "filter": { "id": 77273, "name": "Plan" },
      "createdAt": "2021-10-01T18:32:45.117741",
      "modifiedAt": "2025-10-24T16:00:16.195614",
      "name": "Schiberg",
      "type": "normal",
      "public": false,
      "userdate": "2021-10-01",
      "meta": {
        "length": 11183.8,
        "totalup": 1204.7,
        "totaldown": 1196.2,
        "elemin": 916.8,
        "elemax": 2043.7,
        "walking": 319.9,
        "biking": 99.8,
        "eBiking": 0.0,
        "winterHiking": 399.9,
        "snowshoeTrekking": 479.8,
        "mountainBiking": 107.34970422656922,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1170774042,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2025-08-19T17:27:23.447219",
      "modifiedAt": "2025-10-20T20:18:59.333955",
      "name": "250819 Sure - Triechter",
      "type": "normal",
      "public": true,
      "userdate": "2025-08-19",
      "meta": {
        "length": 1419.4815674558506,
        "totalup": 0.79998779296875,
        "totaldown": 0.0,
        "elemin": 503.79998779296875,
        "elemax": 504.5999755859375,
        "walking": 20.29154492374465,
        "biking": 5.473168123250507,
        "eBiking": 0.0,
        "winterHiking": 25.3,
        "snowshoeTrekking": 30.4,
        "mountainBiking": 5.139646027694601,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "canoeing"
      }
    },
    {
      "id": 7599928,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2020-07-29T10:34:25.300690",
      "modifiedAt": "2025-10-20T20:17:10.420359",
      "name": "200729 Langnau Schüpfheim",
      "type": "normal",
      "public": true,
      "userdate": "2020-07-29",
      "meta": {
        "length": 36760.21957538029,
        "totalup": 928.0000915527344,
        "totaldown": 878.0000915527344,
        "elemin": 669.2999877929688,
        "elemax": 1218.1999816894531,
        "walking": 572.5398301613445,
        "biking": 204.18394819295472,
        "eBiking": 0.0,
        "winterHiking": 715.7999999999997,
        "snowshoeTrekking": 859.1999999999998,
        "mountainBiking": 251.63698544020016,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "velo"
      }
    },
    {
      "id": 1806548603,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-11-01T14:59:29.112272",
      "modifiedAt": "2025-10-20T20:16:34.982002",
      "name": "221101 Turren Eiseesattel",
      "type": "normal",
      "public": true,
      "userdate": "2022-11-01",
      "meta": {
        "length": 42674.46323834865,
        "totalup": 1946.1001586914062,
        "totaldown": 2993.5001525878906,
        "elemin": 483.1999816894531,
        "elemax": 2203.0999755859375,
        "walking": 869.037160940935,
        "biking": 313.6063102593697,
        "eBiking": 0.0,
        "winterHiking": 1085.9999999999998,
        "snowshoeTrekking": 1303.5999999999995,
        "mountainBiking": 304.2497205267149,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 69446493,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-05-18T14:00:32.535430",
      "modifiedAt": "2025-10-20T20:16:23.544716",
      "name": "230518 Beromünster",
      "type": "normal",
      "public": true,
      "userdate": "2023-05-18",
      "meta": {
        "length": 32809.01450195421,
        "totalup": 684.8998413085938,
        "totaldown": 684.9998474121094,
        "elemin": 504.79998779296875,
        "elemax": 809.1999816894531,
        "walking": 497.460898717061,
        "biking": 211.1160367750288,
        "eBiking": 0.0,
        "winterHiking": 621.7000000000002,
        "snowshoeTrekking": 746.3,
        "mountainBiking": 197.46924881978583,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 951762333,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-07-06T20:28:17.201544",
      "modifiedAt": "2025-10-20T20:16:09.522179",
      "name": "230706 Dierikon Sursee",
      "type": "normal",
      "public": true,
      "userdate": "2023-07-06",
      "meta": {
        "length": 36649.218436476614,
        "totalup": 711.0001220703125,
        "totaldown": 622.6001281738281,
        "elemin": 415.5,
        "elemax": 779.7999877929688,
        "walking": 554.121317540738,
        "biking": 237.4623210075184,
        "eBiking": 0.0,
        "winterHiking": 692.4999999999999,
        "snowshoeTrekking": 830.7999999999997,
        "mountainBiking": 222.6411507396695,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 514565581,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2023-09-16T19:56:18.086190",
      "modifiedAt": "2025-10-20T20:15:31.514059",
      "name": "230916 Leidenberg Flüss",
      "type": "normal",
      "public": true,
      "userdate": "2023-09-16",
      "meta": {
        "length": 32397.016850518132,
        "totalup": 736.6998596191406,
        "totaldown": 736.9998474121094,
        "elemin": 498.8999938964844,
        "elemax": 792.5999755859375,
        "walking": 497.309127772279,
        "biking": 220.42887025880623,
        "eBiking": 0.0,
        "winterHiking": 621.4000000000002,
        "snowshoeTrekking": 746.3,
        "mountainBiking": 206.05710829795134,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 492557338,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-09-11T16:00:38.079182",
      "modifiedAt": "2025-10-20T20:15:06.426905",
      "name": "220911 Sursee Triengen",
      "type": "normal",
      "public": true,
      "userdate": "2022-09-11",
      "meta": {
        "length": 42310.71534177248,
        "totalup": 895.1001281738281,
        "totaldown": 882.5001220703125,
        "elemin": 477.0999755859375,
        "elemax": 752.2999877929688,
        "walking": 654.0794802437968,
        "biking": 269.5673958217956,
        "eBiking": 0.0,
        "winterHiking": 817.4000000000003,
        "snowshoeTrekking": 981.1000000000001,
        "mountainBiking": 253.07392030624473,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 695139014,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2025-05-02T15:08:36.416229",
      "modifiedAt": "2025-10-20T20:14:38.245903",
      "name": "250502 Böhler Suhr",
      "type": "normal",
      "public": true,
      "userdate": "2025-05-02",
      "meta": {
        "length": 59087.35178049181,
        "totalup": 929.5001220703125,
        "totaldown": 931.3001403808594,
        "elemin": 408.6999816894531,
        "elemax": 769.7999877929688,
        "walking": 890.2699038985655,
        "biking": 342.66964182023287,
        "eBiking": 0.0,
        "winterHiking": 1112.3999999999996,
        "snowshoeTrekking": 1335.2,
        "mountainBiking": 319.6961103219071,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1096824212,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-06T15:05:05.546909",
      "modifiedAt": "2025-10-20T20:14:23.702512",
      "name": "220806 Col de Mille",
      "type": "normal",
      "public": true,
      "userdate": "2022-08-06",
      "meta": {
        "length": 23997.00417719088,
        "totalup": 1159.9999389648438,
        "totaldown": 1989.2999267578125,
        "elemin": 820.0,
        "elemax": 2478.2999877929688,
        "walking": 490.6684436171266,
        "biking": 195.00302860641122,
        "eBiking": 0.0,
        "winterHiking": 613.2,
        "snowshoeTrekking": 735.9999999999999,
        "mountainBiking": 191.5270417761143,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1753830913,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-10-09T21:56:37.330115",
      "modifiedAt": "2025-10-20T20:13:11.806043",
      "name": "221009 Luzern",
      "type": "normal",
      "public": true,
      "userdate": "2022-10-09",
      "meta": {
        "length": 51212.18727300439,
        "totalup": 1124.8999938964844,
        "totaldown": 1054.8000183105469,
        "elemin": 426.0999755859375,
        "elemax": 1073.0,
        "walking": 796.4190754953231,
        "biking": 356.30629931239065,
        "eBiking": 0.0,
        "winterHiking": 995.5,
        "snowshoeTrekking": 1195.1000000000004,
        "mountainBiking": 333.026765325381,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1078131877,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-04T18:41:06.772133",
      "modifiedAt": "2025-10-20T20:12:43.077750",
      "name": "220804 Verbier",
      "type": "normal",
      "public": true,
      "userdate": "2022-08-04",
      "meta": {
        "length": 12551.350318503437,
        "totalup": 109.0999755859375,
        "totaldown": 1627.5999755859375,
        "elemin": 820.0999755859375,
        "elemax": 2345.7999877929688,
        "walking": 225.2214897622892,
        "biking": 40.271178791433826,
        "eBiking": 0.0,
        "winterHiking": 281.7999999999999,
        "snowshoeTrekking": 338.00000000000006,
        "mountainBiking": 38.93900301452425,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 152125131,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-07-01T18:30:16.624477",
      "modifiedAt": "2025-10-20T20:12:26.434739",
      "name": "220626 Sempachersee",
      "type": "normal",
      "public": true,
      "userdate": "2022-06-26",
      "meta": {
        "length": 44410.43681979488,
        "totalup": 835.6004028320312,
        "totaldown": 835.2003784179688,
        "elemin": 504.5,
        "elemax": 804.5,
        "walking": 668.7635838098344,
        "biking": 282.35771631700385,
        "eBiking": 0.0,
        "winterHiking": 836.0999999999998,
        "snowshoeTrekking": 1003.0999999999998,
        "mountainBiking": 262.7337037633846,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 2001418283,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-08-24T14:11:43.406313",
      "modifiedAt": "2025-10-20T20:12:15.096745",
      "name": "210907 Arvigrat",
      "type": "normal",
      "public": true,
      "userdate": "2021-09-07",
      "meta": {
        "length": 18772.845605976414,
        "totalup": 705.7998352050781,
        "totaldown": 1644.4998168945312,
        "elemin": 471.3999938964844,
        "elemax": 2013.3999938964844,
        "walking": 374.36766843187723,
        "biking": 115.15952793856361,
        "eBiking": 0.0,
        "winterHiking": 467.9000000000001,
        "snowshoeTrekking": 561.6,
        "mountainBiking": 112.81513974011688,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7146536,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-20T20:12:02.998019",
      "name": "210718 Postautotour Glaspass Chur",
      "type": "normal",
      "public": true,
      "userdate": "2021-07-18",
      "meta": {
        "length": 42971.243634292405,
        "totalup": 1166.6002197265625,
        "totaldown": 2422.700225830078,
        "elemin": 556.2999877929688,
        "elemax": 1856.5,
        "walking": 759.0299201270016,
        "biking": 279.92026637318025,
        "eBiking": 0.0,
        "winterHiking": 948.8000000000002,
        "snowshoeTrekking": 1137.8999999999996,
        "mountainBiking": 243.30650927108786,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1041124486,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-04T15:59:56.228945",
      "modifiedAt": "2025-10-20T20:11:37.674769",
      "name": "220804 Verbier",
      "type": "normal",
      "public": true,
      "userdate": "2022-08-04",
      "meta": {
        "length": 10632.057118532783,
        "totalup": 299.89990234375,
        "totaldown": 1238.1999206542969,
        "elemin": 1530.1999816894531,
        "elemax": 2727.199981689453,
        "walking": 209.40322680701604,
        "biking": 56.34619031274949,
        "eBiking": 0.0,
        "winterHiking": 261.8,
        "snowshoeTrekking": 314.09999999999997,
        "mountainBiking": 55.31737609437197,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7146530,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-20T20:11:26.657446",
      "name": "210717 Postautotour Julier Tiefencastel",
      "type": "normal",
      "public": true,
      "userdate": "2021-07-17",
      "meta": {
        "length": 39671.79583018154,
        "totalup": 1058.8999938964844,
        "totaldown": 2326.3999938964844,
        "elemin": 844.6999816894531,
        "elemax": 2151.3999938964844,
        "walking": 669.6909991067345,
        "biking": 286.0188449102669,
        "eBiking": 0.0,
        "winterHiking": 837.1999999999996,
        "snowshoeTrekking": 1005.2000000000004,
        "mountainBiking": 250.0240947902415,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7146529,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-20T20:11:13.538589",
      "name": "210717 Postautotour Bernina St Moritz",
      "type": "normal",
      "public": true,
      "userdate": "2021-07-17",
      "meta": {
        "length": 21169.922240371623,
        "totalup": 352.80023193359375,
        "totaldown": 877.8002319335938,
        "elemin": 1766.0999755859375,
        "elemax": 2304.7999877929688,
        "walking": 323.4213438112137,
        "biking": 121.67083364310183,
        "eBiking": 0.0,
        "winterHiking": 404.6000000000002,
        "snowshoeTrekking": 484.69999999999993,
        "mountainBiking": 101.26086428719958,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 1280234339,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2022-08-05T15:53:20.060302",
      "modifiedAt": "2025-10-20T20:10:55.821280",
      "name": "220804 Verbier",
      "type": "normal",
      "public": true,
      "userdate": "2022-08-04",
      "meta": {
        "length": 11307.91872869141,
        "totalup": 44.29998779296875,
        "totaldown": 1487.5999755859375,
        "elemin": 820.0999755859375,
        "elemax": 2264.3999938964844,
        "walking": 206.52476509136787,
        "biking": 29.689761793796265,
        "eBiking": 0.0,
        "winterHiking": 258.4000000000001,
        "snowshoeTrekking": 309.6000000000001,
        "mountainBiking": 29.010050513404572,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7146528,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-20T20:10:40.029520",
      "name": "210716 Postautotour Umbrail Poschiavo",
      "type": "normal",
      "public": true,
      "userdate": "2021-07-16",
      "meta": {
        "length": 57088.13889703151,
        "totalup": 2601.1000366210938,
        "totaldown": 4088.6000366210938,
        "elemin": 1009.0999755859375,
        "elemax": 2791.5999755859375,
        "walking": 1132.4144110932689,
        "biking": 463.49718346253104,
        "eBiking": 0.0,
        "winterHiking": 1416.0999999999995,
        "snowshoeTrekking": 1699.0000000000005,
        "mountainBiking": 424.697612855189,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 7146510,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2021-10-12T12:40:26.210078",
      "modifiedAt": "2025-10-20T20:10:28.142685",
      "name": "210715 Postautotour Scharl Müstair",
      "type": "normal",
      "public": true,
      "userdate": "2021-07-15",
      "meta": {
        "length": 27586.12820472543,
        "totalup": 1106.2000122070312,
        "totaldown": 1540.9000244140625,
        "elemin": 1264.0999755859375,
        "elemax": 2250.199981689453,
        "walking": 503.4897345254205,
        "biking": 278.47975193829205,
        "eBiking": 0.0,
        "winterHiking": 629.0000000000002,
        "snowshoeTrekking": 755.5000000000003,
        "mountainBiking": 241.8788239359242,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 6720486,
      "filter": { "id": 1773, "name": "Bike" },
      "createdAt": "2020-04-29T16:11:43.978533",
      "modifiedAt": "2025-10-20T20:09:47.283582",
      "name": "191014 Sursee Napf",
      "type": "normal",
      "public": true,
      "userdate": "2019-10-14",
      "meta": {
        "length": 73872.87898625621,
        "totalup": 1931.0563354492188,
        "totaldown": 1930.7576599121094,
        "elemin": 495.29998779296875,
        "elemax": 1304.2999877929688,
        "walking": 1181.1152609542942,
        "biking": 604.4843317953713,
        "eBiking": 0.0,
        "winterHiking": 1476.7000000000003,
        "snowshoeTrekking": 1772.1999999999996,
        "mountainBiking": 504.48444092950695,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "mountain_biking"
      }
    },
    {
      "id": 848836570,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:29:02.952163",
      "modifiedAt": "2025-10-20T20:05:29.274101",
      "name": "070717 Ste Croix Les Charbonnières",
      "type": "normal",
      "public": true,
      "userdate": "2007-07-17",
      "meta": {
        "length": 44202.89918546748,
        "totalup": 1076.9997863769531,
        "totaldown": 1124.9997863769531,
        "elemin": 644.0999755859375,
        "elemax": 1292.7999877929688,
        "walking": 677.410174834219,
        "biking": 234.2148661537117,
        "eBiking": 0.0,
        "winterHiking": 846.9,
        "snowshoeTrekking": 1016.0999999999999,
        "mountainBiking": 297.4607636473602,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 147662371,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:22:57.745467",
      "modifiedAt": "2025-10-20T20:04:54.076038",
      "name": "070716 Le Bémont Ste Croix",
      "type": "normal",
      "public": true,
      "userdate": "2007-07-16",
      "meta": {
        "length": 103273.35392819518,
        "totalup": 1755.899658203125,
        "totaldown": 1657.4996643066406,
        "elemin": 726.2999877929688,
        "elemax": 1248.5999755859375,
        "walking": 1533.4229432384623,
        "biking": 469.838226839938,
        "eBiking": 0.0,
        "winterHiking": 1916.8000000000002,
        "snowshoeTrekking": 2300.1,
        "mountainBiking": 593.5792150400022,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 1079713474,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:32:27.164435",
      "modifiedAt": "2025-10-20T20:04:39.871942",
      "name": "070718 Les Charbonnières Nyon",
      "type": "normal",
      "public": true,
      "userdate": "2007-07-18",
      "meta": {
        "length": 50455.11099284366,
        "totalup": 617.3000183105469,
        "totaldown": 1242.0,
        "elemin": 402.5,
        "elemax": 1353.5999755859375,
        "walking": 730.3762521144134,
        "biking": 188.635986562958,
        "eBiking": 0.0,
        "winterHiking": 912.9,
        "snowshoeTrekking": 1095.6000000000001,
        "mountainBiking": 230.03179452939273,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 13610697,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-17T19:11:13.622701",
      "modifiedAt": "2025-10-20T20:04:27.503833",
      "name": "041005 Gurtnellen Disentis",
      "type": "normal",
      "public": true,
      "userdate": "2004-10-05",
      "meta": {
        "length": 46384.277153606905,
        "totalup": 1409.199951171875,
        "totaldown": 1002.9999694824219,
        "elemin": 734.2999877929688,
        "elemax": 2044.0,
        "walking": 721.5983294515648,
        "biking": 282.5347382743227,
        "eBiking": 0.0,
        "winterHiking": 902.0000000000001,
        "snowshoeTrekking": 1082.3,
        "mountainBiking": 365.21634087465816,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 732816590,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-17T19:13:41.866794",
      "modifiedAt": "2025-10-20T20:04:16.946899",
      "name": "041006 Disentis Bellinzona",
      "type": "normal",
      "public": true,
      "userdate": "2004-10-06",
      "meta": {
        "length": 84042.75376767814,
        "totalup": 1138.2999877929688,
        "totaldown": 2041.4999694824219,
        "elemin": 226.39999389648438,
        "elemax": 1972.2999877929688,
        "walking": 1225.7973761526268,
        "biking": 330.59408708686954,
        "eBiking": 0.0,
        "winterHiking": 1532.2,
        "snowshoeTrekking": 1838.6000000000001,
        "mountainBiking": 413.19376594029666,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 1057302921,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:18:24.529937",
      "modifiedAt": "2025-10-20T20:03:54.505245",
      "name": "070716 Basel Le Bémont",
      "type": "normal",
      "public": true,
      "userdate": "2007-07-08",
      "meta": {
        "length": 93724.10415523738,
        "totalup": 2138.599639892578,
        "totaldown": 1436.5996398925781,
        "elemin": 277.3999938964844,
        "elemax": 1003.6999816894531,
        "walking": 1426.5026857155224,
        "biking": 497.459067168837,
        "eBiking": 0.0,
        "winterHiking": 1783.2,
        "snowshoeTrekking": 2139.9,
        "mountainBiking": 620.3648570065225,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 865425507,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:36:24.122294",
      "modifiedAt": "2025-10-20T20:03:42.282266",
      "name": "0????? Valendas Tamins",
      "type": "normal",
      "public": true,
      "userdate": "2011-07-24",
      "meta": {
        "length": 17345.057284241404,
        "totalup": 277.50006103515625,
        "totaldown": 436.2000732421875,
        "elemin": 591.1999816894531,
        "elemax": 936.0,
        "walking": 255.9696343026364,
        "biking": 73.84544742976973,
        "eBiking": 0.0,
        "winterHiking": 320.0,
        "snowshoeTrekking": 383.9,
        "mountainBiking": 91.92916484961457,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 1918634949,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:16:57.401453",
      "modifiedAt": "2025-10-20T20:03:32.146816",
      "name": "070715 Triengen Basel",
      "type": "normal",
      "public": true,
      "userdate": "2007-07-07",
      "meta": {
        "length": 77520.69082388237,
        "totalup": 815.8995666503906,
        "totaldown": 1052.1995544433594,
        "elemin": 264.6999816894531,
        "elemax": 811.7999877929688,
        "walking": 1131.3371995720338,
        "biking": 297.74613041578135,
        "eBiking": 0.0,
        "winterHiking": 1414.1999999999998,
        "snowshoeTrekking": 1697.2999999999997,
        "mountainBiking": 356.98203775770793,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 822888394,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:38:51.342589",
      "modifiedAt": "2025-10-20T20:03:09.098661",
      "name": "0????? Tamins Chur",
      "type": "normal",
      "public": true,
      "userdate": "2011-07-24",
      "meta": {
        "length": 11450.958481803022,
        "totalup": 79.40005493164062,
        "totaldown": 141.10003662109375,
        "elemin": 561.6999816894531,
        "elemax": 662.0999755859375,
        "walking": 164.0221688491498,
        "biking": 37.94743541709179,
        "eBiking": 0.0,
        "winterHiking": 205.0,
        "snowshoeTrekking": 246.0,
        "mountainBiking": 45.677338105762,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 424048021,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:53:13.191042",
      "modifiedAt": "2025-10-20T20:02:51.581951",
      "name": "0????? Stein am Rhein Winterthur",
      "type": "normal",
      "public": true,
      "userdate": "2011-07-24",
      "meta": {
        "length": 51326.38653705939,
        "totalup": 468.1998291015625,
        "totaldown": 436.0998229980469,
        "elemin": 356.29998779296875,
        "elemax": 455.79998779296875,
        "walking": 744.273965026722,
        "biking": 190.59031289749737,
        "eBiking": 0.0,
        "winterHiking": 930.4,
        "snowshoeTrekking": 1116.4,
        "mountainBiking": 233.0172906852462,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 43958755,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:35:00.566361",
      "modifiedAt": "2025-10-20T20:02:35.588725",
      "name": "0????? Oberalp Valendas",
      "type": "normal",
      "public": true,
      "userdate": "2010-07-24",
      "meta": {
        "length": 59370.07791344126,
        "totalup": 507.0001525878906,
        "totaldown": 1735.5001525878906,
        "elemin": 696.7999877929688,
        "elemax": 2041.0,
        "walking": 848.8941282282937,
        "biking": 188.57781379019593,
        "eBiking": 0.0,
        "winterHiking": 1061.1,
        "snowshoeTrekking": 1273.2,
        "mountainBiking": 225.50683130595507,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 718223933,
      "filter": { "id": 1779, "name": "Velo" },
      "createdAt": "2022-07-24T18:49:38.659512",
      "modifiedAt": "2025-10-20T20:01:43.410976",
      "name": "0????? Altstätten Stein am Rhein",
      "type": "normal",
      "public": true,
      "userdate": "2011-07-24",
      "meta": {
        "length": 108656.45727230208,
        "totalup": 488.00018310546875,
        "totaldown": 538.3001708984375,
        "elemin": 394.1999816894531,
        "elemax": 455.6999816894531,
        "walking": 1557.9862960929788,
        "biking": 357.5383602421316,
        "eBiking": 0.0,
        "winterHiking": 1947.3999999999999,
        "snowshoeTrekking": 2337.0,
        "mountainBiking": 429.18536085645803,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "velo"
      }
    },
    {
      "id": 1856989339,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-05-24T06:51:53.217073",
      "modifiedAt": "2025-05-24T06:51:53.217073",
      "name": "250517 Amden Foodtrail",
      "type": "normal",
      "public": true,
      "userdate": "2025-05-24",
      "meta": {
        "length": 5772.749906644225,
        "totalup": 437.752575683593,
        "totaldown": 438.0987060546868,
        "elemin": 887.0,
        "elemax": 1293.0,
        "walking": 135.4057263071936,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 17.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 406376773,
      "filter": { "id": 1774, "name": "Wandern" },
      "createdAt": "2025-05-24T06:55:18.211368",
      "modifiedAt": "2025-05-24T06:55:18.211368",
      "name": "250523 Stanserhorn",
      "type": "normal",
      "public": true,
      "userdate": "2025-05-24",
      "meta": {
        "length": 15337.970922805369,
        "totalup": 1441.0611877441406,
        "totaldown": 1442.2457275390625,
        "elemin": 450.0,
        "elemax": 1854.0,
        "walking": 408.51579197490435,
        "biking": 0.0,
        "eBiking": 0.0,
        "winterHiking": 0.0,
        "snowshoeTrekking": 0.0,
        "mountainBiking": 17.0,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "red",
        "colorRgb": "#e30613",
        "timetype": "wander"
      }
    },
    {
      "id": 1983469023,
      "filter": { "id": 94631, "name": "Joggedijogg" },
      "createdAt": "2021-06-03T19:38:21.503001",
      "modifiedAt": "2021-06-03T19:38:21.503001",
      "name": "Bachiela",
      "type": "normal",
      "public": true,
      "userdate": "2021-06-03",
      "meta": {
        "length": 30616.2,
        "totalup": 1024.6,
        "totaldown": 1033.3,
        "elemin": 676.0499999999998,
        "elemax": 756.3999999999993,
        "walking": 515.7,
        "biking": 226.9,
        "eBiking": 0.0,
        "winterHiking": 644.6,
        "snowshoeTrekking": 773.6,
        "mountainBiking": 215.64953225405662,
        "eMountainBiking": 0.0
      },
      "pref": {
        "opacity": 100,
        "color": "purple",
        "colorRgb": "#662483",
        "timetype": "wander"
      }
    },
    {
      "id": 1382636061,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2025-07-11T17:55:35.160473",
      "modifiedAt": "2025-11-11T08:47:07.895430",
      "name": "250711 Eich Nottwil",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2025-07-11",
      "meta": {
        "length": 2520.3731186716677,
        "totalup": 24.899926346314828,
        "totaldown": 10.539232147051905,
        "elemin": 488.047127809984,
        "elemax": 512.9470541562988,
        "trackedTime": 131.85,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 131.85,
        "speedAverage": 1.1469274715229434,
        "speedMax": 7.334399700164795
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 1148697764,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2025-06-20T18:39:23.753560",
      "modifiedAt": "2025-11-11T08:46:49.965153",
      "name": "250620 Seepark Triechter",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2025-06-20",
      "meta": {
        "length": 1416.7577055414688,
        "totalup": 0.0,
        "totaldown": 10.759268576176282,
        "elemin": 498.71436025842127,
        "elemax": 514.9780880812051,
        "trackedTime": 50.75,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 50.75,
        "speedAverage": 1.674984479457894,
        "speedMax": 5.292000102996826
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 833620079,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2023-08-12T19:10:00.102772",
      "modifiedAt": "2023-08-13T12:23:18.541293",
      "name": "230812 Badi Schenkon",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2023-08-12",
      "meta": {
        "length": 766.3271788136592,
        "totalup": 0.0,
        "totaldown": 11.160719650400267,
        "elemin": 504.75270142524374,
        "elemax": 516.3799296392651,
        "trackedTime": 28.833333333333332,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 28.833333333333332,
        "speedAverage": 1.594669273831892,
        "speedMax": 5.8807454109191895
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 2067653788,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2023-06-23T18:31:04.557977",
      "modifiedAt": "2023-08-13T12:23:26.974460",
      "name": "230623 See",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2023-06-23",
      "meta": {
        "length": 1539.2933565190388,
        "totalup": 0.0,
        "totaldown": 0.0,
        "elemin": 501.1049072944004,
        "elemax": 506.7895254657299,
        "trackedTime": 75.6,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 75.6,
        "speedAverage": 1.2216613940627292,
        "speedMax": 3.299506330490112
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 843048272,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2023-08-18T18:21:48.941402",
      "modifiedAt": "2023-08-18T18:41:24.802247",
      "name": "230818 Boje",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2023-08-18",
      "meta": {
        "length": 1242.1245497779462,
        "totalup": 0.0,
        "totaldown": 0.0,
        "elemin": 506.4488246176339,
        "elemax": 515.1593374885341,
        "trackedTime": 39.9,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 39.9,
        "speedAverage": 1.867856465831498,
        "speedMax": 4.54070520401001
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 874934713,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2023-08-22T18:13:58.785972",
      "modifiedAt": "2023-08-23T20:59:49.843731",
      "name": "230822 See",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2023-08-22",
      "meta": {
        "length": 1133.3586609785211,
        "totalup": 0.0,
        "totaldown": 0.0,
        "elemin": 506.2976518372282,
        "elemax": 515.8082490703221,
        "trackedTime": 42.03333333333333,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 42.03333333333333,
        "speedAverage": 1.6177998332762396,
        "speedMax": 3.9252021789550784
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 1211483909,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2023-08-23T18:43:18.726886",
      "modifiedAt": "2023-08-23T21:01:14.631484",
      "name": "230823 Gamma-Inseli",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2023-08-23",
      "meta": {
        "length": 1547.856365926228,
        "totalup": 0.0,
        "totaldown": 10.005247114188535,
        "elemin": 502.98986523186846,
        "elemax": 511.7813328907056,
        "trackedTime": 53.35,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 53.35,
        "speedAverage": 1.7407944134128148,
        "speedMax": 4.513258695602417
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 1026928570,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2024-08-30T14:08:37.847642",
      "modifiedAt": "2024-09-01T13:42:30.122228",
      "name": "240830 Eich Nottwil",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2024-08-30",
      "meta": {
        "length": 2432.3874425016434,
        "totalup": 0.0,
        "totaldown": 0.0,
        "elemin": 503.532703847353,
        "elemax": 511.5722811617694,
        "trackedTime": 89.21666666666667,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 89.21666666666667,
        "speedAverage": 1.6358294027659102,
        "speedMax": 2.7161084890365603
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 845967708,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2024-08-15T17:30:55.418980",
      "modifiedAt": "2024-09-01T13:42:55.571780",
      "name": "240815 Sure Buvette",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2024-08-15",
      "meta": {
        "length": 1434.8075884878713,
        "totalup": 0.0,
        "totaldown": 10.880901909332977,
        "elemin": 502.3989367108991,
        "elemax": 513.0297237774222,
        "trackedTime": 65.5,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 65.5,
        "speedAverage": 1.3143275619736225,
        "speedMax": 3.54283504486084
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    },
    {
      "id": 670856161,
      "filter": { "id": 160146, "name": "Schwimmen" },
      "createdAt": "2024-07-25T18:20:28.386417",
      "modifiedAt": "2024-09-01T13:46:23.497791",
      "name": "240725 Donnerstags Schwimmer",
      "type": "recordedtrack",
      "public": true,
      "userdate": "2024-07-25",
      "meta": {
        "length": 1408.404323182818,
        "totalup": 13.265529896002704,
        "totaldown": 0.0,
        "elemin": 486.82463054799155,
        "elemax": 510.14362133671983,
        "trackedTime": 49.2,
        "trackedTimePause": 0.0,
        "trackedTimeTotal": 49.2,
        "speedAverage": 1.7175662477839244,
        "speedMax": 4.357872533798218
      },
      "pref": { "opacity": 100, "color": "red", "colorRgb": "#e30613" }
    }
  ]
}
